var map = {
	"./acrylicProsthesis/acrylicBottom.stl": 707097,
	"./acrylicProsthesis/acrylicTop.stl": 298598,
	"./badSealedCanal/11.stl": 380190,
	"./badSealedCanal/12.stl": 958069,
	"./badSealedCanal/13.stl": 918510,
	"./badSealedCanal/14.stl": 977869,
	"./badSealedCanal/15.stl": 751809,
	"./badSealedCanal/16.stl": 78157,
	"./badSealedCanal/17.stl": 864575,
	"./badSealedCanal/18.stl": 177243,
	"./badSealedCanal/21.stl": 756068,
	"./badSealedCanal/22.stl": 289364,
	"./badSealedCanal/23.stl": 620439,
	"./badSealedCanal/24.stl": 967998,
	"./badSealedCanal/25.stl": 65754,
	"./badSealedCanal/26.stl": 700240,
	"./badSealedCanal/27.stl": 599671,
	"./badSealedCanal/28.stl": 484873,
	"./badSealedCanal/31.stl": 905919,
	"./badSealedCanal/32.stl": 758076,
	"./badSealedCanal/33.stl": 611243,
	"./badSealedCanal/34.stl": 676211,
	"./badSealedCanal/35.stl": 483620,
	"./badSealedCanal/36.stl": 116399,
	"./badSealedCanal/37.stl": 469795,
	"./badSealedCanal/38.stl": 351436,
	"./badSealedCanal/41.stl": 980626,
	"./badSealedCanal/42.stl": 202132,
	"./badSealedCanal/43.stl": 201222,
	"./badSealedCanal/44.stl": 801859,
	"./badSealedCanal/45.stl": 257121,
	"./badSealedCanal/46.stl": 186809,
	"./badSealedCanal/47.stl": 768741,
	"./badSealedCanal/48.stl": 499789,
	"./badSealedCanal2/11.stl": 132121,
	"./badSealedCanal2/12.stl": 669310,
	"./badSealedCanal2/13.stl": 835778,
	"./badSealedCanal2/14.stl": 946093,
	"./badSealedCanal2/15.stl": 216569,
	"./badSealedCanal2/16.stl": 727604,
	"./badSealedCanal2/17.stl": 788934,
	"./badSealedCanal2/18.stl": 876002,
	"./badSealedCanal2/21.stl": 308542,
	"./badSealedCanal2/22.stl": 273167,
	"./badSealedCanal2/23.stl": 231799,
	"./badSealedCanal2/24.stl": 256123,
	"./badSealedCanal2/25.stl": 140692,
	"./badSealedCanal2/26.stl": 382791,
	"./badSealedCanal2/27.stl": 242949,
	"./badSealedCanal2/28.stl": 563843,
	"./badSealedCanal2/31.stl": 405851,
	"./badSealedCanal2/32.stl": 880232,
	"./badSealedCanal2/33.stl": 335067,
	"./badSealedCanal2/34.stl": 374101,
	"./badSealedCanal2/35.stl": 605873,
	"./badSealedCanal2/36.stl": 10441,
	"./badSealedCanal2/37.stl": 847208,
	"./badSealedCanal2/38.stl": 78794,
	"./badSealedCanal2/41.stl": 637566,
	"./badSealedCanal2/42.stl": 809290,
	"./badSealedCanal2/43.stl": 360529,
	"./badSealedCanal2/44.stl": 498149,
	"./badSealedCanal2/45.stl": 976583,
	"./badSealedCanal2/46.stl": 389510,
	"./badSealedCanal2/47.stl": 630888,
	"./badSealedCanal2/48.stl": 544014,
	"./basicBones/Canal.stl": 818505,
	"./basicBones/JointDiskLeft.stl": 401439,
	"./basicBones/JointDiskRight.stl": 36955,
	"./basicBones/Mandibula.stl": 166254,
	"./basicBones/Skull.stl": 255835,
	"./basicBones/softTissue.stl": 993551,
	"./boneAugmentation/11.stl": 696470,
	"./boneAugmentation/12.stl": 30442,
	"./boneAugmentation/13.stl": 794487,
	"./boneAugmentation/14.stl": 35856,
	"./boneAugmentation/15.stl": 590513,
	"./boneAugmentation/16.stl": 812928,
	"./boneAugmentation/17.stl": 112742,
	"./boneAugmentation/18.stl": 38061,
	"./boneAugmentation/21.stl": 779892,
	"./boneAugmentation/22.stl": 170344,
	"./boneAugmentation/23.stl": 874377,
	"./boneAugmentation/24.stl": 470790,
	"./boneAugmentation/25.stl": 759803,
	"./boneAugmentation/26.stl": 687716,
	"./boneAugmentation/27.stl": 860017,
	"./boneAugmentation/28.stl": 677396,
	"./boneAugmentation/31.stl": 112963,
	"./boneAugmentation/32.stl": 280358,
	"./boneAugmentation/33.stl": 301278,
	"./boneAugmentation/34.stl": 167378,
	"./boneAugmentation/35.stl": 191237,
	"./boneAugmentation/36.stl": 495834,
	"./boneAugmentation/37.stl": 293559,
	"./boneAugmentation/38.stl": 400352,
	"./boneAugmentation/41.stl": 207051,
	"./boneAugmentation/42.stl": 644749,
	"./boneAugmentation/43.stl": 213285,
	"./boneAugmentation/44.stl": 845715,
	"./boneAugmentation/45.stl": 628682,
	"./boneAugmentation/46.stl": 75879,
	"./boneAugmentation/47.stl": 273080,
	"./boneAugmentation/48.stl": 175348,
	"./brokenTool/11.stl": 555344,
	"./brokenTool/12.stl": 964985,
	"./brokenTool/13.stl": 774596,
	"./brokenTool/14.stl": 114802,
	"./brokenTool/15.stl": 566035,
	"./brokenTool/16.stl": 201256,
	"./brokenTool/17.stl": 950889,
	"./brokenTool/18.stl": 161759,
	"./brokenTool/21.stl": 997737,
	"./brokenTool/22.stl": 633154,
	"./brokenTool/23.stl": 989328,
	"./brokenTool/24.stl": 663661,
	"./brokenTool/25.stl": 866721,
	"./brokenTool/26.stl": 109339,
	"./brokenTool/27.stl": 290228,
	"./brokenTool/28.stl": 370841,
	"./brokenTool/31.stl": 692548,
	"./brokenTool/32.stl": 781484,
	"./brokenTool/33.stl": 509011,
	"./brokenTool/34.stl": 558364,
	"./brokenTool/35.stl": 104506,
	"./brokenTool/36.stl": 103256,
	"./brokenTool/37.stl": 564161,
	"./brokenTool/38.stl": 168589,
	"./brokenTool/41.stl": 132264,
	"./brokenTool/42.stl": 267755,
	"./brokenTool/43.stl": 548992,
	"./brokenTool/44.stl": 113652,
	"./brokenTool/45.stl": 464905,
	"./brokenTool/46.stl": 512024,
	"./brokenTool/47.stl": 258384,
	"./brokenTool/48.stl": 619289,
	"./canal/11.stl": 949907,
	"./canal/12.stl": 590371,
	"./canal/13.stl": 124025,
	"./canal/14.stl": 117474,
	"./canal/15.stl": 434062,
	"./canal/16.stl": 837319,
	"./canal/17.stl": 271437,
	"./canal/18.stl": 663761,
	"./canal/21.stl": 863678,
	"./canal/22.stl": 624036,
	"./canal/23.stl": 423331,
	"./canal/24.stl": 36174,
	"./canal/25.stl": 353851,
	"./canal/26.stl": 666914,
	"./canal/27.stl": 753180,
	"./canal/28.stl": 932930,
	"./canal/31.stl": 625494,
	"./canal/32.stl": 206351,
	"./canal/33.stl": 182398,
	"./canal/34.stl": 136498,
	"./canal/35.stl": 840173,
	"./canal/36.stl": 226750,
	"./canal/37.stl": 203183,
	"./canal/38.stl": 68412,
	"./canal/41.stl": 321660,
	"./canal/42.stl": 449829,
	"./canal/43.stl": 950009,
	"./canal/44.stl": 58987,
	"./canal/45.stl": 307402,
	"./canal/46.stl": 139574,
	"./canal/47.stl": 847437,
	"./canal/48.stl": 979578,
	"./capaProsthesis/capaBottom.stl": 216129,
	"./capaProsthesis/capaTop.stl": 938551,
	"./cariousTooth/11.stl": 278731,
	"./cariousTooth/12.stl": 939705,
	"./cariousTooth/13.stl": 271557,
	"./cariousTooth/14.stl": 326211,
	"./cariousTooth/15.stl": 786108,
	"./cariousTooth/16.stl": 31417,
	"./cariousTooth/17.stl": 367521,
	"./cariousTooth/18.stl": 771295,
	"./cariousTooth/21.stl": 291800,
	"./cariousTooth/22.stl": 838343,
	"./cariousTooth/23.stl": 574679,
	"./cariousTooth/24.stl": 531289,
	"./cariousTooth/25.stl": 309740,
	"./cariousTooth/26.stl": 200605,
	"./cariousTooth/27.stl": 979883,
	"./cariousTooth/28.stl": 84038,
	"./cariousTooth/31.stl": 771670,
	"./cariousTooth/32.stl": 598106,
	"./cariousTooth/33.stl": 822418,
	"./cariousTooth/34.stl": 700513,
	"./cariousTooth/35.stl": 745251,
	"./cariousTooth/36.stl": 226623,
	"./cariousTooth/37.stl": 115973,
	"./cariousTooth/38.stl": 269324,
	"./cariousTooth/41.stl": 894826,
	"./cariousTooth/42.stl": 908616,
	"./cariousTooth/43.stl": 758081,
	"./cariousTooth/44.stl": 895386,
	"./cariousTooth/45.stl": 370373,
	"./cariousTooth/46.stl": 703349,
	"./cariousTooth/47.stl": 463857,
	"./cariousTooth/48.stl": 943583,
	"./cariousToothHole/11.stl": 496741,
	"./cariousToothHole/12.stl": 659910,
	"./cariousToothHole/13.stl": 278263,
	"./cariousToothHole/14.stl": 486449,
	"./cariousToothHole/15.stl": 501930,
	"./cariousToothHole/16.stl": 346078,
	"./cariousToothHole/17.stl": 767383,
	"./cariousToothHole/18.stl": 322327,
	"./cariousToothHole/21.stl": 645521,
	"./cariousToothHole/22.stl": 629066,
	"./cariousToothHole/23.stl": 240017,
	"./cariousToothHole/24.stl": 260347,
	"./cariousToothHole/25.stl": 722744,
	"./cariousToothHole/26.stl": 779095,
	"./cariousToothHole/27.stl": 166029,
	"./cariousToothHole/28.stl": 597279,
	"./cariousToothHole/31.stl": 594053,
	"./cariousToothHole/32.stl": 441990,
	"./cariousToothHole/33.stl": 488959,
	"./cariousToothHole/34.stl": 120512,
	"./cariousToothHole/35.stl": 233032,
	"./cariousToothHole/36.stl": 549244,
	"./cariousToothHole/37.stl": 793014,
	"./cariousToothHole/38.stl": 851066,
	"./cariousToothHole/41.stl": 372845,
	"./cariousToothHole/42.stl": 332791,
	"./cariousToothHole/43.stl": 124482,
	"./cariousToothHole/44.stl": 730793,
	"./cariousToothHole/45.stl": 168555,
	"./cariousToothHole/46.stl": 203207,
	"./cariousToothHole/47.stl": 634249,
	"./cariousToothHole/48.stl": 710198,
	"./clutchProsthesis/clutchBottom.stl": 814525,
	"./clutchProsthesis/clutchTop.stl": 165736,
	"./compositeFilling/11.stl": 893750,
	"./compositeFilling/12.stl": 18434,
	"./compositeFilling/13.stl": 778633,
	"./compositeFilling/14.stl": 724179,
	"./compositeFilling/15.stl": 764596,
	"./compositeFilling/16.stl": 455891,
	"./compositeFilling/17.stl": 948906,
	"./compositeFilling/18.stl": 82488,
	"./compositeFilling/21.stl": 328088,
	"./compositeFilling/22.stl": 156859,
	"./compositeFilling/23.stl": 92411,
	"./compositeFilling/24.stl": 216179,
	"./compositeFilling/25.stl": 186822,
	"./compositeFilling/26.stl": 87071,
	"./compositeFilling/27.stl": 789495,
	"./compositeFilling/28.stl": 736805,
	"./compositeFilling/31.stl": 40316,
	"./compositeFilling/32.stl": 15491,
	"./compositeFilling/33.stl": 414306,
	"./compositeFilling/34.stl": 85479,
	"./compositeFilling/35.stl": 470317,
	"./compositeFilling/36.stl": 80296,
	"./compositeFilling/37.stl": 112558,
	"./compositeFilling/38.stl": 340368,
	"./compositeFilling/41.stl": 4290,
	"./compositeFilling/42.stl": 66020,
	"./compositeFilling/43.stl": 889234,
	"./compositeFilling/44.stl": 724483,
	"./compositeFilling/45.stl": 643754,
	"./compositeFilling/46.stl": 411011,
	"./compositeFilling/47.stl": 572343,
	"./compositeFilling/48.stl": 336331,
	"./compositeFillingTab/11.stl": 478634,
	"./compositeFillingTab/12.stl": 395496,
	"./compositeFillingTab/13.stl": 268536,
	"./compositeFillingTab/14.stl": 749712,
	"./compositeFillingTab/15.stl": 375560,
	"./compositeFillingTab/16.stl": 483150,
	"./compositeFillingTab/17.stl": 959807,
	"./compositeFillingTab/18.stl": 763058,
	"./compositeFillingTab/21.stl": 427314,
	"./compositeFillingTab/22.stl": 145241,
	"./compositeFillingTab/23.stl": 820128,
	"./compositeFillingTab/24.stl": 475581,
	"./compositeFillingTab/25.stl": 274458,
	"./compositeFillingTab/26.stl": 984300,
	"./compositeFillingTab/27.stl": 376961,
	"./compositeFillingTab/28.stl": 693636,
	"./compositeFillingTab/31.stl": 250994,
	"./compositeFillingTab/32.stl": 280875,
	"./compositeFillingTab/33.stl": 574633,
	"./compositeFillingTab/34.stl": 609049,
	"./compositeFillingTab/35.stl": 187254,
	"./compositeFillingTab/36.stl": 793627,
	"./compositeFillingTab/37.stl": 584253,
	"./compositeFillingTab/38.stl": 978436,
	"./compositeFillingTab/41.stl": 853312,
	"./compositeFillingTab/42.stl": 217391,
	"./compositeFillingTab/43.stl": 776582,
	"./compositeFillingTab/44.stl": 216238,
	"./compositeFillingTab/45.stl": 581531,
	"./compositeFillingTab/46.stl": 945562,
	"./compositeFillingTab/47.stl": 148749,
	"./compositeFillingTab/48.stl": 632500,
	"./connection/1112.stl": 624305,
	"./connection/1213.stl": 246663,
	"./connection/1314.stl": 680527,
	"./connection/1415.stl": 532155,
	"./connection/1516.stl": 166162,
	"./connection/1617.stl": 487585,
	"./connection/1718.stl": 906705,
	"./connection/2111.stl": 348515,
	"./connection/2221.stl": 91441,
	"./connection/2322.stl": 380738,
	"./connection/2423.stl": 76347,
	"./connection/2524.stl": 586171,
	"./connection/2625.stl": 828465,
	"./connection/2726.stl": 587916,
	"./connection/2827.stl": 877423,
	"./connection/3132.stl": 90979,
	"./connection/3233.stl": 680196,
	"./connection/3334.stl": 257712,
	"./connection/3435.stl": 924741,
	"./connection/3536.stl": 815653,
	"./connection/3637.stl": 734533,
	"./connection/3738.stl": 386506,
	"./connection/4131.stl": 118597,
	"./connection/4241.stl": 701063,
	"./connection/4342.stl": 893548,
	"./connection/4443.stl": 222029,
	"./connection/4544.stl": 550237,
	"./connection/4645.stl": 173772,
	"./connection/4746.stl": 604141,
	"./connection/4847.stl": 836475,
	"./corticalBoneImplants/11.stl": 956394,
	"./corticalBoneImplants/12.stl": 791676,
	"./corticalBoneImplants/13.stl": 376075,
	"./corticalBoneImplants/14.stl": 798098,
	"./corticalBoneImplants/15.stl": 683705,
	"./corticalBoneImplants/16.stl": 665635,
	"./corticalBoneImplants/17.stl": 105925,
	"./corticalBoneImplants/18.stl": 927034,
	"./corticalBoneImplants/21.stl": 983622,
	"./corticalBoneImplants/22.stl": 729282,
	"./corticalBoneImplants/23.stl": 509591,
	"./corticalBoneImplants/24.stl": 62417,
	"./corticalBoneImplants/25.stl": 161451,
	"./corticalBoneImplants/26.stl": 553175,
	"./corticalBoneImplants/27.stl": 215641,
	"./corticalBoneImplants/28.stl": 466145,
	"./corticalBoneImplants/31.stl": 7521,
	"./corticalBoneImplants/32.stl": 976752,
	"./corticalBoneImplants/33.stl": 266713,
	"./corticalBoneImplants/34.stl": 692308,
	"./corticalBoneImplants/35.stl": 266372,
	"./corticalBoneImplants/36.stl": 558120,
	"./corticalBoneImplants/37.stl": 357375,
	"./corticalBoneImplants/38.stl": 223273,
	"./corticalBoneImplants/41.stl": 132026,
	"./corticalBoneImplants/42.stl": 828435,
	"./corticalBoneImplants/43.stl": 192768,
	"./corticalBoneImplants/44.stl": 346144,
	"./corticalBoneImplants/45.stl": 470938,
	"./corticalBoneImplants/46.stl": 59934,
	"./corticalBoneImplants/47.stl": 408917,
	"./corticalBoneImplants/48.stl": 72174,
	"./crown/11.stl": 532637,
	"./crown/12.stl": 698498,
	"./crown/13.stl": 237010,
	"./crown/14.stl": 394993,
	"./crown/15.stl": 950112,
	"./crown/16.stl": 945666,
	"./crown/17.stl": 851465,
	"./crown/18.stl": 796446,
	"./crown/21.stl": 636250,
	"./crown/22.stl": 811268,
	"./crown/23.stl": 388228,
	"./crown/24.stl": 467463,
	"./crown/25.stl": 750757,
	"./crown/26.stl": 515573,
	"./crown/27.stl": 703113,
	"./crown/28.stl": 594598,
	"./crown/31.stl": 276961,
	"./crown/32.stl": 463365,
	"./crown/33.stl": 385982,
	"./crown/34.stl": 350700,
	"./crown/35.stl": 784685,
	"./crown/36.stl": 164104,
	"./crown/37.stl": 217588,
	"./crown/38.stl": 241332,
	"./crown/41.stl": 268845,
	"./crown/42.stl": 482616,
	"./crown/43.stl": 166120,
	"./crown/44.stl": 389644,
	"./crown/45.stl": 200932,
	"./crown/46.stl": 646802,
	"./crown/47.stl": 532929,
	"./crown/48.stl": 570660,
	"./cyst_1/11.stl": 87579,
	"./cyst_1/12.stl": 322507,
	"./cyst_1/13.stl": 542060,
	"./cyst_1/14.stl": 168271,
	"./cyst_1/15.stl": 621576,
	"./cyst_1/16.stl": 376826,
	"./cyst_1/17.stl": 378119,
	"./cyst_1/18.stl": 105378,
	"./cyst_1/21.stl": 708326,
	"./cyst_1/22.stl": 997217,
	"./cyst_1/23.stl": 961247,
	"./cyst_1/24.stl": 414341,
	"./cyst_1/25.stl": 310017,
	"./cyst_1/26.stl": 808511,
	"./cyst_1/27.stl": 826023,
	"./cyst_1/28.stl": 402590,
	"./cyst_1/31.stl": 124416,
	"./cyst_1/32.stl": 210711,
	"./cyst_1/33.stl": 939585,
	"./cyst_1/34.stl": 598495,
	"./cyst_1/35.stl": 272956,
	"./cyst_1/36.stl": 94153,
	"./cyst_1/37.stl": 554189,
	"./cyst_1/38.stl": 849735,
	"./cyst_1/41.stl": 596282,
	"./cyst_1/42.stl": 746055,
	"./cyst_1/43.stl": 503818,
	"./cyst_1/44.stl": 798238,
	"./cyst_1/45.stl": 768965,
	"./cyst_1/46.stl": 410653,
	"./cyst_1/47.stl": 255203,
	"./cyst_1/48.stl": 611255,
	"./cyst_2/14.stl": 160953,
	"./cyst_2/16.stl": 239205,
	"./cyst_2/17.stl": 153067,
	"./cyst_2/18.stl": 141275,
	"./cyst_2/24.stl": 695282,
	"./cyst_2/26.stl": 665987,
	"./cyst_2/27.stl": 230447,
	"./cyst_2/28.stl": 354555,
	"./cyst_2/36.stl": 86356,
	"./cyst_2/37.stl": 845423,
	"./cyst_2/38.stl": 763007,
	"./cyst_2/46.stl": 532381,
	"./cyst_2/47.stl": 362678,
	"./cyst_2/48.stl": 832763,
	"./cyst_3/16.stl": 660220,
	"./cyst_3/17.stl": 676964,
	"./cyst_3/18.stl": 460442,
	"./cyst_3/26.stl": 837116,
	"./cyst_3/27.stl": 68327,
	"./cyst_3/28.stl": 541806,
	"./decayedToothRoot/11.stl": 393061,
	"./decayedToothRoot/12.stl": 724566,
	"./decayedToothRoot/13.stl": 517314,
	"./decayedToothRoot/14.stl": 488458,
	"./decayedToothRoot/15.stl": 732829,
	"./decayedToothRoot/16.stl": 272008,
	"./decayedToothRoot/17.stl": 961120,
	"./decayedToothRoot/18.stl": 718249,
	"./decayedToothRoot/21.stl": 840589,
	"./decayedToothRoot/22.stl": 401296,
	"./decayedToothRoot/23.stl": 162719,
	"./decayedToothRoot/24.stl": 913267,
	"./decayedToothRoot/25.stl": 399478,
	"./decayedToothRoot/26.stl": 826337,
	"./decayedToothRoot/27.stl": 485541,
	"./decayedToothRoot/28.stl": 745150,
	"./decayedToothRoot/31.stl": 410713,
	"./decayedToothRoot/32.stl": 125010,
	"./decayedToothRoot/33.stl": 591777,
	"./decayedToothRoot/34.stl": 594609,
	"./decayedToothRoot/35.stl": 724888,
	"./decayedToothRoot/36.stl": 969251,
	"./decayedToothRoot/37.stl": 155903,
	"./decayedToothRoot/38.stl": 486670,
	"./decayedToothRoot/41.stl": 875919,
	"./decayedToothRoot/42.stl": 685525,
	"./decayedToothRoot/43.stl": 657261,
	"./decayedToothRoot/44.stl": 117249,
	"./decayedToothRoot/45.stl": 849868,
	"./decayedToothRoot/46.stl": 283617,
	"./decayedToothRoot/47.stl": 51239,
	"./decayedToothRoot/48.stl": 691301,
	"./decayedToothTop/11.stl": 898028,
	"./decayedToothTop/12.stl": 322653,
	"./decayedToothTop/13.stl": 435594,
	"./decayedToothTop/14.stl": 468918,
	"./decayedToothTop/15.stl": 639693,
	"./decayedToothTop/16.stl": 88526,
	"./decayedToothTop/17.stl": 378325,
	"./decayedToothTop/18.stl": 350522,
	"./decayedToothTop/21.stl": 494353,
	"./decayedToothTop/22.stl": 967241,
	"./decayedToothTop/23.stl": 129885,
	"./decayedToothTop/24.stl": 808445,
	"./decayedToothTop/25.stl": 967269,
	"./decayedToothTop/26.stl": 328582,
	"./decayedToothTop/27.stl": 460690,
	"./decayedToothTop/28.stl": 31304,
	"./decayedToothTop/31.stl": 647991,
	"./decayedToothTop/32.stl": 312294,
	"./decayedToothTop/33.stl": 130508,
	"./decayedToothTop/34.stl": 885013,
	"./decayedToothTop/35.stl": 851165,
	"./decayedToothTop/36.stl": 524887,
	"./decayedToothTop/37.stl": 913634,
	"./decayedToothTop/38.stl": 279063,
	"./decayedToothTop/41.stl": 509844,
	"./decayedToothTop/42.stl": 730069,
	"./decayedToothTop/43.stl": 70802,
	"./decayedToothTop/44.stl": 471982,
	"./decayedToothTop/45.stl": 700071,
	"./decayedToothTop/46.stl": 51689,
	"./decayedToothTop/47.stl": 425681,
	"./decayedToothTop/48.stl": 199614,
	"./dentalBar/11.stl": 415678,
	"./dentalBar/12.stl": 345960,
	"./dentalBar/13.stl": 311685,
	"./dentalBar/14.stl": 191302,
	"./dentalBar/15.stl": 928452,
	"./dentalBar/16.stl": 535981,
	"./dentalBar/17.stl": 583597,
	"./dentalBar/21.stl": 154178,
	"./dentalBar/22.stl": 885644,
	"./dentalBar/23.stl": 347361,
	"./dentalBar/24.stl": 984310,
	"./dentalBar/25.stl": 17916,
	"./dentalBar/26.stl": 302602,
	"./dentalBar/27.stl": 358462,
	"./dentalBar/31.stl": 685448,
	"./dentalBar/32.stl": 379928,
	"./dentalBar/33.stl": 262050,
	"./dentalBar/34.stl": 38565,
	"./dentalBar/35.stl": 68012,
	"./dentalBar/36.stl": 247531,
	"./dentalBar/37.stl": 665008,
	"./dentalBar/41.stl": 574073,
	"./dentalBar/42.stl": 996796,
	"./dentalBar/43.stl": 58674,
	"./dentalBar/44.stl": 807756,
	"./dentalBar/45.stl": 426749,
	"./dentalBar/46.stl": 809142,
	"./dentalBar/47.stl": 634545,
	"./elastopositioner/elastopositioner.stl": 284608,
	"./emptyTooth/11.stl": 639472,
	"./emptyTooth/12.stl": 900972,
	"./emptyTooth/13.stl": 413649,
	"./emptyTooth/14.stl": 575241,
	"./emptyTooth/15.stl": 916883,
	"./emptyTooth/16.stl": 63042,
	"./emptyTooth/17.stl": 742875,
	"./emptyTooth/18.stl": 563999,
	"./emptyTooth/21.stl": 979463,
	"./emptyTooth/22.stl": 35603,
	"./emptyTooth/23.stl": 541450,
	"./emptyTooth/24.stl": 359101,
	"./emptyTooth/25.stl": 129717,
	"./emptyTooth/26.stl": 603655,
	"./emptyTooth/27.stl": 41042,
	"./emptyTooth/28.stl": 96608,
	"./emptyTooth/31.stl": 638335,
	"./emptyTooth/32.stl": 526480,
	"./emptyTooth/33.stl": 251906,
	"./emptyTooth/34.stl": 609418,
	"./emptyTooth/35.stl": 293574,
	"./emptyTooth/36.stl": 915901,
	"./emptyTooth/37.stl": 460130,
	"./emptyTooth/38.stl": 223191,
	"./emptyTooth/41.stl": 878007,
	"./emptyTooth/42.stl": 112449,
	"./emptyTooth/43.stl": 41132,
	"./emptyTooth/44.stl": 920627,
	"./emptyTooth/45.stl": 693438,
	"./emptyTooth/46.stl": 102505,
	"./emptyTooth/47.stl": 653099,
	"./emptyTooth/48.stl": 974413,
	"./granulomaCyst/11.stl": 132909,
	"./granulomaCyst/12.stl": 861050,
	"./granulomaCyst/13.stl": 696842,
	"./granulomaCyst/14.stl": 860618,
	"./granulomaCyst/15.stl": 951843,
	"./granulomaCyst/16.stl": 226307,
	"./granulomaCyst/17.stl": 196138,
	"./granulomaCyst/18.stl": 957208,
	"./granulomaCyst/21.stl": 582145,
	"./granulomaCyst/22.stl": 655353,
	"./granulomaCyst/23.stl": 335238,
	"./granulomaCyst/24.stl": 271386,
	"./granulomaCyst/25.stl": 951231,
	"./granulomaCyst/26.stl": 38499,
	"./granulomaCyst/27.stl": 828064,
	"./granulomaCyst/28.stl": 432763,
	"./granulomaCyst/31.stl": 160415,
	"./granulomaCyst/32.stl": 232862,
	"./granulomaCyst/33.stl": 30624,
	"./granulomaCyst/34.stl": 214703,
	"./granulomaCyst/35.stl": 987813,
	"./granulomaCyst/36.stl": 552052,
	"./granulomaCyst/37.stl": 64047,
	"./granulomaCyst/38.stl": 836728,
	"./granulomaCyst/41.stl": 128174,
	"./granulomaCyst/42.stl": 917827,
	"./granulomaCyst/43.stl": 417624,
	"./granulomaCyst/44.stl": 510259,
	"./granulomaCyst/45.stl": 569466,
	"./granulomaCyst/46.stl": 757894,
	"./granulomaCyst/47.stl": 324846,
	"./granulomaCyst/48.stl": 159437,
	"./gum/gum_bottom.stl": 342533,
	"./gum/gum_top.stl": 293686,
	"./healthyTooth/11.stl": 855997,
	"./healthyTooth/12.stl": 904103,
	"./healthyTooth/13.stl": 488077,
	"./healthyTooth/14.stl": 355139,
	"./healthyTooth/15.stl": 429833,
	"./healthyTooth/16.stl": 783119,
	"./healthyTooth/17.stl": 251522,
	"./healthyTooth/18.stl": 730490,
	"./healthyTooth/21.stl": 255248,
	"./healthyTooth/22.stl": 878066,
	"./healthyTooth/23.stl": 280356,
	"./healthyTooth/24.stl": 20385,
	"./healthyTooth/25.stl": 466829,
	"./healthyTooth/26.stl": 318826,
	"./healthyTooth/27.stl": 546047,
	"./healthyTooth/28.stl": 443915,
	"./healthyTooth/31.stl": 605902,
	"./healthyTooth/32.stl": 516372,
	"./healthyTooth/33.stl": 640784,
	"./healthyTooth/34.stl": 823550,
	"./healthyTooth/35.stl": 303651,
	"./healthyTooth/36.stl": 287373,
	"./healthyTooth/37.stl": 698970,
	"./healthyTooth/38.stl": 36491,
	"./healthyTooth/41.stl": 48638,
	"./healthyTooth/42.stl": 29558,
	"./healthyTooth/43.stl": 357866,
	"./healthyTooth/44.stl": 729814,
	"./healthyTooth/45.stl": 357630,
	"./healthyTooth/46.stl": 706711,
	"./healthyTooth/47.stl": 296923,
	"./healthyTooth/48.stl": 892047,
	"./healthyToothCrown/11.stl": 293106,
	"./healthyToothCrown/12.stl": 630637,
	"./healthyToothCrown/13.stl": 247059,
	"./healthyToothCrown/14.stl": 733582,
	"./healthyToothCrown/15.stl": 614882,
	"./healthyToothCrown/16.stl": 258398,
	"./healthyToothCrown/17.stl": 766005,
	"./healthyToothCrown/18.stl": 55572,
	"./healthyToothCrown/21.stl": 18938,
	"./healthyToothCrown/22.stl": 934410,
	"./healthyToothCrown/23.stl": 447193,
	"./healthyToothCrown/24.stl": 95081,
	"./healthyToothCrown/25.stl": 167306,
	"./healthyToothCrown/26.stl": 733986,
	"./healthyToothCrown/27.stl": 93830,
	"./healthyToothCrown/28.stl": 534330,
	"./healthyToothCrown/31.stl": 353925,
	"./healthyToothCrown/32.stl": 590842,
	"./healthyToothCrown/33.stl": 449324,
	"./healthyToothCrown/34.stl": 63313,
	"./healthyToothCrown/35.stl": 118303,
	"./healthyToothCrown/36.stl": 573243,
	"./healthyToothCrown/37.stl": 419240,
	"./healthyToothCrown/38.stl": 778359,
	"./healthyToothCrown/41.stl": 437125,
	"./healthyToothCrown/42.stl": 649832,
	"./healthyToothCrown/43.stl": 685489,
	"./healthyToothCrown/44.stl": 452192,
	"./healthyToothCrown/45.stl": 541909,
	"./healthyToothCrown/46.stl": 503997,
	"./healthyToothCrown/47.stl": 871045,
	"./healthyToothCrown/48.stl": 586421,
	"./healthyToothRoot/11.stl": 837756,
	"./healthyToothRoot/12.stl": 106560,
	"./healthyToothRoot/13.stl": 280036,
	"./healthyToothRoot/14.stl": 803546,
	"./healthyToothRoot/15.stl": 777310,
	"./healthyToothRoot/16.stl": 626997,
	"./healthyToothRoot/17.stl": 83190,
	"./healthyToothRoot/18.stl": 236615,
	"./healthyToothRoot/21.stl": 93631,
	"./healthyToothRoot/22.stl": 57851,
	"./healthyToothRoot/23.stl": 305604,
	"./healthyToothRoot/24.stl": 558104,
	"./healthyToothRoot/25.stl": 629025,
	"./healthyToothRoot/26.stl": 933305,
	"./healthyToothRoot/27.stl": 650266,
	"./healthyToothRoot/28.stl": 499399,
	"./healthyToothRoot/31.stl": 219762,
	"./healthyToothRoot/32.stl": 212101,
	"./healthyToothRoot/33.stl": 594492,
	"./healthyToothRoot/34.stl": 655675,
	"./healthyToothRoot/35.stl": 178202,
	"./healthyToothRoot/36.stl": 891638,
	"./healthyToothRoot/37.stl": 11562,
	"./healthyToothRoot/38.stl": 791947,
	"./healthyToothRoot/41.stl": 9177,
	"./healthyToothRoot/42.stl": 900405,
	"./healthyToothRoot/43.stl": 311495,
	"./healthyToothRoot/44.stl": 686082,
	"./healthyToothRoot/45.stl": 252111,
	"./healthyToothRoot/46.stl": 33824,
	"./healthyToothRoot/47.stl": 106419,
	"./healthyToothRoot/48.stl": 170306,
	"./implantPosition/11.stl": 164618,
	"./implantPosition/12.stl": 61397,
	"./implantPosition/13.stl": 906700,
	"./implantPosition/14.stl": 549163,
	"./implantPosition/15.stl": 564764,
	"./implantPosition/16.stl": 281332,
	"./implantPosition/17.stl": 575912,
	"./implantPosition/18.stl": 372119,
	"./implantPosition/21.stl": 547596,
	"./implantPosition/22.stl": 680148,
	"./implantPosition/23.stl": 762471,
	"./implantPosition/24.stl": 990766,
	"./implantPosition/25.stl": 258364,
	"./implantPosition/26.stl": 704434,
	"./implantPosition/27.stl": 749737,
	"./implantPosition/28.stl": 671456,
	"./implantPosition/31.stl": 574588,
	"./implantPosition/32.stl": 58433,
	"./implantPosition/33.stl": 173578,
	"./implantPosition/34.stl": 75089,
	"./implantPosition/35.stl": 614203,
	"./implantPosition/36.stl": 473012,
	"./implantPosition/37.stl": 83305,
	"./implantPosition/38.stl": 813594,
	"./implantPosition/41.stl": 901371,
	"./implantPosition/42.stl": 683414,
	"./implantPosition/43.stl": 758721,
	"./implantPosition/44.stl": 720775,
	"./implantPosition/45.stl": 958234,
	"./implantPosition/46.stl": 591940,
	"./implantPosition/47.stl": 529319,
	"./implantPosition/48.stl": 427996,
	"./implantsGum/11.stl": 545059,
	"./implantsGum/12.stl": 366109,
	"./implantsGum/13.stl": 781970,
	"./implantsGum/14.stl": 543706,
	"./implantsGum/15.stl": 728432,
	"./implantsGum/16.stl": 910198,
	"./implantsGum/17.stl": 315665,
	"./implantsGum/18.stl": 405465,
	"./implantsGum/21.stl": 404144,
	"./implantsGum/22.stl": 399024,
	"./implantsGum/23.stl": 213322,
	"./implantsGum/24.stl": 641638,
	"./implantsGum/25.stl": 485308,
	"./implantsGum/26.stl": 947100,
	"./implantsGum/27.stl": 681394,
	"./implantsGum/28.stl": 86877,
	"./implantsGum/31.stl": 369990,
	"./implantsGum/32.stl": 104422,
	"./implantsGum/33.stl": 189271,
	"./implantsGum/34.stl": 672840,
	"./implantsGum/35.stl": 10129,
	"./implantsGum/36.stl": 597650,
	"./implantsGum/37.stl": 503860,
	"./implantsGum/38.stl": 798715,
	"./implantsGum/41.stl": 36777,
	"./implantsGum/42.stl": 791328,
	"./implantsGum/43.stl": 818487,
	"./implantsGum/44.stl": 502104,
	"./implantsGum/45.stl": 52909,
	"./implantsGum/46.stl": 93766,
	"./implantsGum/47.stl": 422421,
	"./implantsGum/48.stl": 385841,
	"./individualAbutment/11.stl": 357833,
	"./individualAbutment/12.stl": 770406,
	"./individualAbutment/13.stl": 819784,
	"./individualAbutment/14.stl": 931501,
	"./individualAbutment/15.stl": 99143,
	"./individualAbutment/16.stl": 158307,
	"./individualAbutment/17.stl": 126872,
	"./individualAbutment/18.stl": 551659,
	"./individualAbutment/21.stl": 284569,
	"./individualAbutment/22.stl": 579240,
	"./individualAbutment/23.stl": 785320,
	"./individualAbutment/24.stl": 591520,
	"./individualAbutment/25.stl": 893097,
	"./individualAbutment/26.stl": 156927,
	"./individualAbutment/27.stl": 96406,
	"./individualAbutment/28.stl": 186092,
	"./individualAbutment/31.stl": 575091,
	"./individualAbutment/32.stl": 333215,
	"./individualAbutment/33.stl": 460783,
	"./individualAbutment/34.stl": 158849,
	"./individualAbutment/35.stl": 197195,
	"./individualAbutment/36.stl": 892541,
	"./individualAbutment/37.stl": 746264,
	"./individualAbutment/38.stl": 406757,
	"./individualAbutment/41.stl": 493306,
	"./individualAbutment/42.stl": 846800,
	"./individualAbutment/43.stl": 122598,
	"./individualAbutment/44.stl": 525736,
	"./individualAbutment/45.stl": 797702,
	"./individualAbutment/46.stl": 126816,
	"./individualAbutment/47.stl": 578682,
	"./individualAbutment/48.stl": 853736,
	"./individualAbutmentCrowns/11.stl": 209395,
	"./individualAbutmentCrowns/12.stl": 34688,
	"./individualAbutmentCrowns/13.stl": 812493,
	"./individualAbutmentCrowns/14.stl": 475268,
	"./individualAbutmentCrowns/15.stl": 2279,
	"./individualAbutmentCrowns/16.stl": 29937,
	"./individualAbutmentCrowns/17.stl": 840134,
	"./individualAbutmentCrowns/18.stl": 909107,
	"./individualAbutmentCrowns/21.stl": 135722,
	"./individualAbutmentCrowns/22.stl": 10706,
	"./individualAbutmentCrowns/23.stl": 134657,
	"./individualAbutmentCrowns/24.stl": 765007,
	"./individualAbutmentCrowns/25.stl": 243252,
	"./individualAbutmentCrowns/26.stl": 726629,
	"./individualAbutmentCrowns/27.stl": 696339,
	"./individualAbutmentCrowns/28.stl": 954143,
	"./individualAbutmentCrowns/31.stl": 208965,
	"./individualAbutmentCrowns/32.stl": 574990,
	"./individualAbutmentCrowns/33.stl": 452549,
	"./individualAbutmentCrowns/34.stl": 703415,
	"./individualAbutmentCrowns/35.stl": 499597,
	"./individualAbutmentCrowns/36.stl": 71584,
	"./individualAbutmentCrowns/37.stl": 755327,
	"./individualAbutmentCrowns/38.stl": 194745,
	"./individualAbutmentCrowns/41.stl": 197545,
	"./individualAbutmentCrowns/42.stl": 441600,
	"./individualAbutmentCrowns/43.stl": 837639,
	"./individualAbutmentCrowns/44.stl": 162321,
	"./individualAbutmentCrowns/45.stl": 126970,
	"./individualAbutmentCrowns/46.stl": 569177,
	"./individualAbutmentCrowns/47.stl": 266193,
	"./individualAbutmentCrowns/48.stl": 6672,
	"./miniImplant/1112.stl": 377957,
	"./miniImplant/1213.stl": 625487,
	"./miniImplant/1314.stl": 684792,
	"./miniImplant/1415.stl": 896506,
	"./miniImplant/1516.stl": 483326,
	"./miniImplant/1617.stl": 390598,
	"./miniImplant/1718.stl": 995738,
	"./miniImplant/2111.stl": 96675,
	"./miniImplant/2221.stl": 543782,
	"./miniImplant/2322.stl": 741274,
	"./miniImplant/2423.stl": 104333,
	"./miniImplant/2524.stl": 774102,
	"./miniImplant/2625.stl": 88565,
	"./miniImplant/2726.stl": 198373,
	"./miniImplant/2827.stl": 964857,
	"./miniImplant/3132.stl": 153642,
	"./miniImplant/3233.stl": 687493,
	"./miniImplant/3334.stl": 457684,
	"./miniImplant/3435.stl": 131660,
	"./miniImplant/3536.stl": 351027,
	"./miniImplant/3637.stl": 508898,
	"./miniImplant/3738.stl": 538899,
	"./miniImplant/4131.stl": 372554,
	"./miniImplant/4241.stl": 50778,
	"./miniImplant/4342.stl": 842790,
	"./miniImplant/4443.stl": 723390,
	"./miniImplant/4544.stl": 645995,
	"./miniImplant/4645.stl": 442358,
	"./miniImplant/4746.stl": 619785,
	"./miniImplant/4847.stl": 939895,
	"./multiunitAbutment/11.stl": 114510,
	"./multiunitAbutment/12.stl": 925154,
	"./multiunitAbutment/13.stl": 914969,
	"./multiunitAbutment/14.stl": 853238,
	"./multiunitAbutment/15.stl": 465491,
	"./multiunitAbutment/16.stl": 778298,
	"./multiunitAbutment/17.stl": 999948,
	"./multiunitAbutment/18.stl": 613066,
	"./multiunitAbutment/21.stl": 927361,
	"./multiunitAbutment/22.stl": 806390,
	"./multiunitAbutment/23.stl": 262078,
	"./multiunitAbutment/24.stl": 244961,
	"./multiunitAbutment/25.stl": 120980,
	"./multiunitAbutment/26.stl": 349343,
	"./multiunitAbutment/27.stl": 717425,
	"./multiunitAbutment/28.stl": 834426,
	"./multiunitAbutment/31.stl": 461581,
	"./multiunitAbutment/32.stl": 222028,
	"./multiunitAbutment/33.stl": 365451,
	"./multiunitAbutment/34.stl": 535299,
	"./multiunitAbutment/35.stl": 543165,
	"./multiunitAbutment/36.stl": 477902,
	"./multiunitAbutment/37.stl": 404272,
	"./multiunitAbutment/38.stl": 560660,
	"./multiunitAbutment/41.stl": 671527,
	"./multiunitAbutment/42.stl": 948482,
	"./multiunitAbutment/43.stl": 370736,
	"./multiunitAbutment/44.stl": 848434,
	"./multiunitAbutment/45.stl": 662274,
	"./multiunitAbutment/46.stl": 979298,
	"./multiunitAbutment/47.stl": 603620,
	"./multiunitAbutment/48.stl": 643170,
	"./multiunitPlatform/11.stl": 734046,
	"./multiunitPlatform/12.stl": 922545,
	"./multiunitPlatform/13.stl": 81454,
	"./multiunitPlatform/14.stl": 564883,
	"./multiunitPlatform/15.stl": 410258,
	"./multiunitPlatform/16.stl": 760526,
	"./multiunitPlatform/17.stl": 230443,
	"./multiunitPlatform/18.stl": 265749,
	"./multiunitPlatform/21.stl": 614272,
	"./multiunitPlatform/22.stl": 375504,
	"./multiunitPlatform/23.stl": 441656,
	"./multiunitPlatform/24.stl": 920870,
	"./multiunitPlatform/25.stl": 193198,
	"./multiunitPlatform/26.stl": 394202,
	"./multiunitPlatform/27.stl": 765010,
	"./multiunitPlatform/28.stl": 466551,
	"./multiunitPlatform/31.stl": 358642,
	"./multiunitPlatform/32.stl": 261218,
	"./multiunitPlatform/33.stl": 624507,
	"./multiunitPlatform/34.stl": 809933,
	"./multiunitPlatform/35.stl": 290148,
	"./multiunitPlatform/36.stl": 955197,
	"./multiunitPlatform/37.stl": 345128,
	"./multiunitPlatform/38.stl": 602444,
	"./multiunitPlatform/41.stl": 939507,
	"./multiunitPlatform/42.stl": 82591,
	"./multiunitPlatform/43.stl": 227023,
	"./multiunitPlatform/44.stl": 475090,
	"./multiunitPlatform/45.stl": 194590,
	"./multiunitPlatform/46.stl": 861067,
	"./multiunitPlatform/47.stl": 901787,
	"./multiunitPlatform/48.stl": 554214,
	"./multiunitScrew/11.stl": 267894,
	"./multiunitScrew/12.stl": 991842,
	"./multiunitScrew/13.stl": 445076,
	"./multiunitScrew/14.stl": 633228,
	"./multiunitScrew/15.stl": 89453,
	"./multiunitScrew/16.stl": 837574,
	"./multiunitScrew/17.stl": 898864,
	"./multiunitScrew/18.stl": 997038,
	"./multiunitScrew/21.stl": 746971,
	"./multiunitScrew/22.stl": 88193,
	"./multiunitScrew/23.stl": 675535,
	"./multiunitScrew/24.stl": 699067,
	"./multiunitScrew/25.stl": 683824,
	"./multiunitScrew/26.stl": 135578,
	"./multiunitScrew/27.stl": 32795,
	"./multiunitScrew/28.stl": 873826,
	"./multiunitScrew/31.stl": 250336,
	"./multiunitScrew/32.stl": 839792,
	"./multiunitScrew/33.stl": 137170,
	"./multiunitScrew/34.stl": 798168,
	"./multiunitScrew/35.stl": 199742,
	"./multiunitScrew/36.stl": 493034,
	"./multiunitScrew/37.stl": 762656,
	"./multiunitScrew/38.stl": 235383,
	"./multiunitScrew/41.stl": 152430,
	"./multiunitScrew/42.stl": 191822,
	"./multiunitScrew/43.stl": 104132,
	"./multiunitScrew/44.stl": 792407,
	"./multiunitScrew/45.stl": 667406,
	"./multiunitScrew/46.stl": 729490,
	"./multiunitScrew/47.stl": 926859,
	"./multiunitScrew/48.stl": 787632,
	"./newEsteticTooth/11.stl": 464839,
	"./newEsteticTooth/12.stl": 985960,
	"./newEsteticTooth/13.stl": 315635,
	"./newEsteticTooth/14.stl": 673470,
	"./newEsteticTooth/15.stl": 87291,
	"./newEsteticTooth/16.stl": 393571,
	"./newEsteticTooth/17.stl": 138728,
	"./newEsteticTooth/18.stl": 106465,
	"./newEsteticTooth/21.stl": 935469,
	"./newEsteticTooth/22.stl": 823782,
	"./newEsteticTooth/23.stl": 691722,
	"./newEsteticTooth/24.stl": 356905,
	"./newEsteticTooth/25.stl": 283436,
	"./newEsteticTooth/26.stl": 384150,
	"./newEsteticTooth/27.stl": 81068,
	"./newEsteticTooth/28.stl": 349347,
	"./newEsteticTooth/31.stl": 374601,
	"./newEsteticTooth/32.stl": 846509,
	"./newEsteticTooth/33.stl": 514378,
	"./newEsteticTooth/34.stl": 797741,
	"./newEsteticTooth/35.stl": 278043,
	"./newEsteticTooth/36.stl": 968353,
	"./newEsteticTooth/37.stl": 842416,
	"./newEsteticTooth/38.stl": 385333,
	"./newEsteticTooth/41.stl": 662520,
	"./newEsteticTooth/42.stl": 853911,
	"./newEsteticTooth/43.stl": 422265,
	"./newEsteticTooth/44.stl": 74989,
	"./newEsteticTooth/45.stl": 807429,
	"./newEsteticTooth/46.stl": 777081,
	"./newEsteticTooth/47.stl": 988957,
	"./newEsteticTooth/48.stl": 574023,
	"./oldEsteticTooth/11.stl": 338240,
	"./oldEsteticTooth/12.stl": 954873,
	"./oldEsteticTooth/13.stl": 85587,
	"./oldEsteticTooth/14.stl": 499433,
	"./oldEsteticTooth/15.stl": 739057,
	"./oldEsteticTooth/16.stl": 64899,
	"./oldEsteticTooth/17.stl": 12143,
	"./oldEsteticTooth/18.stl": 757704,
	"./oldEsteticTooth/21.stl": 479590,
	"./oldEsteticTooth/22.stl": 898792,
	"./oldEsteticTooth/23.stl": 97602,
	"./oldEsteticTooth/24.stl": 337629,
	"./oldEsteticTooth/25.stl": 584762,
	"./oldEsteticTooth/26.stl": 983578,
	"./oldEsteticTooth/27.stl": 132574,
	"./oldEsteticTooth/28.stl": 39905,
	"./oldEsteticTooth/31.stl": 576752,
	"./oldEsteticTooth/32.stl": 318717,
	"./oldEsteticTooth/33.stl": 710189,
	"./oldEsteticTooth/34.stl": 992708,
	"./oldEsteticTooth/35.stl": 632958,
	"./oldEsteticTooth/36.stl": 292309,
	"./oldEsteticTooth/37.stl": 550262,
	"./oldEsteticTooth/38.stl": 614644,
	"./oldEsteticTooth/41.stl": 603105,
	"./oldEsteticTooth/42.stl": 208236,
	"./oldEsteticTooth/43.stl": 9488,
	"./oldEsteticTooth/44.stl": 504102,
	"./oldEsteticTooth/45.stl": 729869,
	"./oldEsteticTooth/46.stl": 6538,
	"./oldEsteticTooth/47.stl": 27187,
	"./oldEsteticTooth/48.stl": 708209,
	"./orthodonticPlateProsthesis/orthodonticPlateBottom.stl": 233053,
	"./orthodonticPlateProsthesis/orthodonticPlateKlammerBottom.stl": 558674,
	"./orthodonticPlateProsthesis/orthodonticPlateKlammerTop.stl": 69894,
	"./orthodonticPlateProsthesis/orthodonticPlateLockBottom.stl": 693522,
	"./orthodonticPlateProsthesis/orthodonticPlateLockTop.stl": 582162,
	"./orthodonticPlateProsthesis/orthodonticPlateNutBottom.stl": 632410,
	"./orthodonticPlateProsthesis/orthodonticPlateNutTop.stl": 715525,
	"./orthodonticPlateProsthesis/orthodonticPlateTop.stl": 684861,
	"./overPress/11.stl": 225678,
	"./overPress/12.stl": 535766,
	"./overPress/13.stl": 475616,
	"./overPress/14.stl": 452702,
	"./overPress/15.stl": 827550,
	"./overPress/16.stl": 897872,
	"./overPress/17.stl": 727661,
	"./overPress/21.stl": 820585,
	"./overPress/22.stl": 953400,
	"./overPress/23.stl": 229131,
	"./overPress/24.stl": 287258,
	"./overPress/25.stl": 405748,
	"./overPress/26.stl": 189584,
	"./overPress/27.stl": 118957,
	"./overPress/31.stl": 362408,
	"./overPress/32.stl": 536466,
	"./overPress/33.stl": 7169,
	"./overPress/34.stl": 511367,
	"./overPress/35.stl": 526746,
	"./overPress/36.stl": 333160,
	"./overPress/37.stl": 944696,
	"./overPress/41.stl": 599154,
	"./overPress/42.stl": 945131,
	"./overPress/43.stl": 942829,
	"./overPress/44.stl": 874431,
	"./overPress/45.stl": 256091,
	"./overPress/46.stl": 552724,
	"./overPress/47.stl": 34361,
	"./preparedTooth/11.stl": 708649,
	"./preparedTooth/12.stl": 389929,
	"./preparedTooth/13.stl": 136274,
	"./preparedTooth/14.stl": 200823,
	"./preparedTooth/15.stl": 671638,
	"./preparedTooth/16.stl": 770651,
	"./preparedTooth/17.stl": 339171,
	"./preparedTooth/18.stl": 717977,
	"./preparedTooth/21.stl": 761224,
	"./preparedTooth/22.stl": 424377,
	"./preparedTooth/23.stl": 537090,
	"./preparedTooth/24.stl": 859277,
	"./preparedTooth/25.stl": 307491,
	"./preparedTooth/26.stl": 315489,
	"./preparedTooth/27.stl": 248711,
	"./preparedTooth/28.stl": 617603,
	"./preparedTooth/31.stl": 282877,
	"./preparedTooth/32.stl": 282396,
	"./preparedTooth/33.stl": 683151,
	"./preparedTooth/34.stl": 103673,
	"./preparedTooth/35.stl": 578574,
	"./preparedTooth/36.stl": 253978,
	"./preparedTooth/37.stl": 261795,
	"./preparedTooth/38.stl": 753634,
	"./preparedTooth/41.stl": 487755,
	"./preparedTooth/42.stl": 348645,
	"./preparedTooth/43.stl": 945203,
	"./preparedTooth/44.stl": 309918,
	"./preparedTooth/45.stl": 658947,
	"./preparedTooth/46.stl": 542137,
	"./preparedTooth/47.stl": 856029,
	"./preparedTooth/48.stl": 269641,
	"./pulp/11.stl": 82906,
	"./pulp/12.stl": 769218,
	"./pulp/13.stl": 352330,
	"./pulp/14.stl": 600300,
	"./pulp/15.stl": 242104,
	"./pulp/16.stl": 90217,
	"./pulp/17.stl": 886349,
	"./pulp/18.stl": 983055,
	"./pulp/21.stl": 925421,
	"./pulp/22.stl": 37476,
	"./pulp/23.stl": 226648,
	"./pulp/24.stl": 890205,
	"./pulp/25.stl": 303996,
	"./pulp/26.stl": 843714,
	"./pulp/27.stl": 704999,
	"./pulp/28.stl": 671122,
	"./pulp/31.stl": 361249,
	"./pulp/32.stl": 704848,
	"./pulp/33.stl": 251737,
	"./pulp/34.stl": 276109,
	"./pulp/35.stl": 574701,
	"./pulp/36.stl": 549399,
	"./pulp/37.stl": 511436,
	"./pulp/38.stl": 4003,
	"./pulp/41.stl": 226614,
	"./pulp/42.stl": 962651,
	"./pulp/43.stl": 519333,
	"./pulp/44.stl": 73498,
	"./pulp/45.stl": 211602,
	"./pulp/46.stl": 511048,
	"./pulp/47.stl": 945050,
	"./pulp/48.stl": 386440,
	"./reducedTooth/11.stl": 509366,
	"./reducedTooth/12.stl": 458382,
	"./reducedTooth/13.stl": 673917,
	"./reducedTooth/14.stl": 535048,
	"./reducedTooth/15.stl": 508180,
	"./reducedTooth/16.stl": 911913,
	"./reducedTooth/17.stl": 849695,
	"./reducedTooth/18.stl": 238405,
	"./reducedTooth/21.stl": 368434,
	"./reducedTooth/22.stl": 163591,
	"./reducedTooth/23.stl": 4499,
	"./reducedTooth/24.stl": 500181,
	"./reducedTooth/25.stl": 305716,
	"./reducedTooth/26.stl": 544515,
	"./reducedTooth/27.stl": 150035,
	"./reducedTooth/28.stl": 425970,
	"./reducedTooth/31.stl": 296905,
	"./reducedTooth/32.stl": 776174,
	"./reducedTooth/33.stl": 355573,
	"./reducedTooth/34.stl": 18617,
	"./reducedTooth/35.stl": 604676,
	"./reducedTooth/36.stl": 969245,
	"./reducedTooth/37.stl": 149843,
	"./reducedTooth/38.stl": 436260,
	"./reducedTooth/41.stl": 403522,
	"./reducedTooth/42.stl": 300149,
	"./reducedTooth/43.stl": 346963,
	"./reducedTooth/44.stl": 352324,
	"./reducedTooth/45.stl": 686560,
	"./reducedTooth/46.stl": 652934,
	"./reducedTooth/47.stl": 789636,
	"./reducedTooth/48.stl": 773933,
	"./screwFixationCrowns/11.stl": 499697,
	"./screwFixationCrowns/12.stl": 957074,
	"./screwFixationCrowns/13.stl": 544532,
	"./screwFixationCrowns/14.stl": 69465,
	"./screwFixationCrowns/15.stl": 254993,
	"./screwFixationCrowns/16.stl": 476154,
	"./screwFixationCrowns/17.stl": 974568,
	"./screwFixationCrowns/18.stl": 596808,
	"./screwFixationCrowns/21.stl": 170833,
	"./screwFixationCrowns/22.stl": 359467,
	"./screwFixationCrowns/23.stl": 76013,
	"./screwFixationCrowns/24.stl": 156121,
	"./screwFixationCrowns/25.stl": 88965,
	"./screwFixationCrowns/26.stl": 319648,
	"./screwFixationCrowns/27.stl": 341987,
	"./screwFixationCrowns/28.stl": 180197,
	"./screwFixationCrowns/31.stl": 144769,
	"./screwFixationCrowns/32.stl": 205712,
	"./screwFixationCrowns/33.stl": 874864,
	"./screwFixationCrowns/34.stl": 659754,
	"./screwFixationCrowns/35.stl": 639328,
	"./screwFixationCrowns/36.stl": 734925,
	"./screwFixationCrowns/37.stl": 979073,
	"./screwFixationCrowns/38.stl": 114620,
	"./screwFixationCrowns/41.stl": 754775,
	"./screwFixationCrowns/42.stl": 455131,
	"./screwFixationCrowns/43.stl": 346310,
	"./screwFixationCrowns/44.stl": 923918,
	"./screwFixationCrowns/45.stl": 417609,
	"./screwFixationCrowns/46.stl": 620309,
	"./screwFixationCrowns/47.stl": 718210,
	"./screwFixationCrowns/48.stl": 930082,
	"./screws/11.stl": 574764,
	"./screws/12.stl": 627770,
	"./screws/13.stl": 347314,
	"./screws/14.stl": 415932,
	"./screws/15.stl": 201186,
	"./screws/16.stl": 743839,
	"./screws/17.stl": 135223,
	"./screws/18.stl": 266575,
	"./screws/21.stl": 414245,
	"./screws/22.stl": 643527,
	"./screws/23.stl": 589425,
	"./screws/24.stl": 791074,
	"./screws/25.stl": 161016,
	"./screws/26.stl": 96795,
	"./screws/27.stl": 887869,
	"./screws/28.stl": 864783,
	"./screws/31.stl": 760022,
	"./screws/32.stl": 417634,
	"./screws/33.stl": 652365,
	"./screws/34.stl": 163992,
	"./screws/35.stl": 918229,
	"./screws/36.stl": 465244,
	"./screws/37.stl": 885736,
	"./screws/38.stl": 499364,
	"./screws/41.stl": 437917,
	"./screws/42.stl": 524783,
	"./screws/43.stl": 391082,
	"./screws/44.stl": 771480,
	"./screws/45.stl": 706801,
	"./screws/46.stl": 873643,
	"./screws/47.stl": 637556,
	"./screws/48.stl": 411562,
	"./sectionTooth_01/11.stl": 531612,
	"./sectionTooth_01/12.stl": 726340,
	"./sectionTooth_01/13.stl": 794887,
	"./sectionTooth_01/14.stl": 9525,
	"./sectionTooth_01/15.stl": 802395,
	"./sectionTooth_01/16.stl": 793362,
	"./sectionTooth_01/17.stl": 470677,
	"./sectionTooth_01/18.stl": 845799,
	"./sectionTooth_01/21.stl": 67591,
	"./sectionTooth_01/22.stl": 431619,
	"./sectionTooth_01/23.stl": 514858,
	"./sectionTooth_01/24.stl": 977957,
	"./sectionTooth_01/25.stl": 876104,
	"./sectionTooth_01/26.stl": 207229,
	"./sectionTooth_01/27.stl": 144695,
	"./sectionTooth_01/28.stl": 262067,
	"./sectionTooth_01/31.stl": 767563,
	"./sectionTooth_01/32.stl": 806671,
	"./sectionTooth_01/33.stl": 73710,
	"./sectionTooth_01/34.stl": 882937,
	"./sectionTooth_01/35.stl": 482328,
	"./sectionTooth_01/36.stl": 918010,
	"./sectionTooth_01/37.stl": 792795,
	"./sectionTooth_01/38.stl": 348382,
	"./sectionTooth_01/41.stl": 413316,
	"./sectionTooth_01/42.stl": 373751,
	"./sectionTooth_01/43.stl": 529971,
	"./sectionTooth_01/44.stl": 74903,
	"./sectionTooth_01/45.stl": 10735,
	"./sectionTooth_01/46.stl": 827401,
	"./sectionTooth_01/47.stl": 896537,
	"./sectionTooth_01/48.stl": 619868,
	"./sectionTooth_02/14.stl": 11493,
	"./sectionTooth_02/16.stl": 283618,
	"./sectionTooth_02/17.stl": 220189,
	"./sectionTooth_02/18.stl": 561597,
	"./sectionTooth_02/24.stl": 329127,
	"./sectionTooth_02/26.stl": 109922,
	"./sectionTooth_02/27.stl": 72712,
	"./sectionTooth_02/28.stl": 675998,
	"./sectionTooth_02/36.stl": 218562,
	"./sectionTooth_02/37.stl": 3168,
	"./sectionTooth_02/38.stl": 587073,
	"./sectionTooth_02/46.stl": 834474,
	"./sectionTooth_02/47.stl": 506704,
	"./sectionTooth_02/48.stl": 734881,
	"./sectionTooth_03/16.stl": 252511,
	"./sectionTooth_03/17.stl": 382333,
	"./sectionTooth_03/18.stl": 875493,
	"./sectionTooth_03/26.stl": 372138,
	"./sectionTooth_03/27.stl": 656337,
	"./sectionTooth_03/28.stl": 887011,
	"./sectionTooth_1/11.stl": 61874,
	"./sectionTooth_1/12.stl": 439074,
	"./sectionTooth_1/13.stl": 271249,
	"./sectionTooth_1/14.stl": 461195,
	"./sectionTooth_1/15.stl": 426987,
	"./sectionTooth_1/16.stl": 429531,
	"./sectionTooth_1/17.stl": 786758,
	"./sectionTooth_1/18.stl": 655307,
	"./sectionTooth_1/21.stl": 621749,
	"./sectionTooth_1/22.stl": 858371,
	"./sectionTooth_1/23.stl": 382584,
	"./sectionTooth_1/24.stl": 620361,
	"./sectionTooth_1/25.stl": 698017,
	"./sectionTooth_1/26.stl": 467163,
	"./sectionTooth_1/27.stl": 803089,
	"./sectionTooth_1/28.stl": 508437,
	"./sectionTooth_1/31.stl": 410654,
	"./sectionTooth_1/32.stl": 312907,
	"./sectionTooth_1/33.stl": 604317,
	"./sectionTooth_1/34.stl": 687254,
	"./sectionTooth_1/35.stl": 154532,
	"./sectionTooth_1/36.stl": 397461,
	"./sectionTooth_1/37.stl": 229008,
	"./sectionTooth_1/38.stl": 417754,
	"./sectionTooth_1/41.stl": 661134,
	"./sectionTooth_1/42.stl": 534823,
	"./sectionTooth_1/43.stl": 272949,
	"./sectionTooth_1/44.stl": 814221,
	"./sectionTooth_1/45.stl": 183758,
	"./sectionTooth_1/46.stl": 987273,
	"./sectionTooth_1/47.stl": 76816,
	"./sectionTooth_1/48.stl": 904456,
	"./sectionTooth_2/11.stl": 816925,
	"./sectionTooth_2/12.stl": 48328,
	"./sectionTooth_2/13.stl": 436830,
	"./sectionTooth_2/14.stl": 497628,
	"./sectionTooth_2/15.stl": 389965,
	"./sectionTooth_2/16.stl": 536019,
	"./sectionTooth_2/17.stl": 545894,
	"./sectionTooth_2/18.stl": 699690,
	"./sectionTooth_2/21.stl": 941580,
	"./sectionTooth_2/22.stl": 908844,
	"./sectionTooth_2/23.stl": 468691,
	"./sectionTooth_2/24.stl": 686001,
	"./sectionTooth_2/25.stl": 409033,
	"./sectionTooth_2/26.stl": 828699,
	"./sectionTooth_2/27.stl": 821081,
	"./sectionTooth_2/28.stl": 43867,
	"./sectionTooth_2/31.stl": 880824,
	"./sectionTooth_2/32.stl": 684613,
	"./sectionTooth_2/33.stl": 920150,
	"./sectionTooth_2/34.stl": 425520,
	"./sectionTooth_2/35.stl": 262313,
	"./sectionTooth_2/36.stl": 609414,
	"./sectionTooth_2/37.stl": 226191,
	"./sectionTooth_2/38.stl": 243285,
	"./sectionTooth_2/41.stl": 347960,
	"./sectionTooth_2/42.stl": 298087,
	"./sectionTooth_2/43.stl": 960818,
	"./sectionTooth_2/44.stl": 291989,
	"./sectionTooth_2/45.stl": 774009,
	"./sectionTooth_2/46.stl": 497182,
	"./sectionTooth_2/47.stl": 618891,
	"./sectionTooth_2/48.stl": 92458,
	"./sectionTooth_3/11.stl": 728862,
	"./sectionTooth_3/12.stl": 309077,
	"./sectionTooth_3/13.stl": 631264,
	"./sectionTooth_3/14.stl": 733297,
	"./sectionTooth_3/15.stl": 739151,
	"./sectionTooth_3/16.stl": 698959,
	"./sectionTooth_3/17.stl": 353507,
	"./sectionTooth_3/18.stl": 424277,
	"./sectionTooth_3/21.stl": 557916,
	"./sectionTooth_3/22.stl": 567056,
	"./sectionTooth_3/23.stl": 262111,
	"./sectionTooth_3/24.stl": 777064,
	"./sectionTooth_3/25.stl": 527616,
	"./sectionTooth_3/26.stl": 431834,
	"./sectionTooth_3/27.stl": 847169,
	"./sectionTooth_3/28.stl": 256353,
	"./sectionTooth_3/31.stl": 794338,
	"./sectionTooth_3/32.stl": 142224,
	"./sectionTooth_3/33.stl": 822131,
	"./sectionTooth_3/34.stl": 297325,
	"./sectionTooth_3/35.stl": 949031,
	"./sectionTooth_3/36.stl": 887630,
	"./sectionTooth_3/37.stl": 236987,
	"./sectionTooth_3/38.stl": 564381,
	"./sectionTooth_3/41.stl": 249177,
	"./sectionTooth_3/42.stl": 362318,
	"./sectionTooth_3/43.stl": 866550,
	"./sectionTooth_3/44.stl": 809246,
	"./sectionTooth_3/45.stl": 336477,
	"./sectionTooth_3/46.stl": 939309,
	"./sectionTooth_3/47.stl": 2049,
	"./sectionTooth_3/48.stl": 127815,
	"./sectionTooth_4/11.stl": 903978,
	"./sectionTooth_4/12.stl": 226308,
	"./sectionTooth_4/13.stl": 146710,
	"./sectionTooth_4/14.stl": 771410,
	"./sectionTooth_4/15.stl": 741415,
	"./sectionTooth_4/16.stl": 653691,
	"./sectionTooth_4/17.stl": 897166,
	"./sectionTooth_4/18.stl": 497421,
	"./sectionTooth_4/21.stl": 333643,
	"./sectionTooth_4/22.stl": 331321,
	"./sectionTooth_4/23.stl": 186630,
	"./sectionTooth_4/24.stl": 153659,
	"./sectionTooth_4/25.stl": 920902,
	"./sectionTooth_4/26.stl": 452778,
	"./sectionTooth_4/27.stl": 769412,
	"./sectionTooth_4/28.stl": 202940,
	"./sectionTooth_4/31.stl": 134886,
	"./sectionTooth_4/32.stl": 88340,
	"./sectionTooth_4/33.stl": 207074,
	"./sectionTooth_4/34.stl": 940667,
	"./sectionTooth_4/35.stl": 288063,
	"./sectionTooth_4/36.stl": 274429,
	"./sectionTooth_4/37.stl": 165632,
	"./sectionTooth_4/38.stl": 649249,
	"./sectionTooth_4/41.stl": 748130,
	"./sectionTooth_4/42.stl": 736152,
	"./sectionTooth_4/43.stl": 461168,
	"./sectionTooth_4/44.stl": 3504,
	"./sectionTooth_4/45.stl": 628863,
	"./sectionTooth_4/46.stl": 449996,
	"./sectionTooth_4/47.stl": 132855,
	"./sectionTooth_4/48.stl": 671512,
	"./sectionTooth_5/11.stl": 25594,
	"./sectionTooth_5/12.stl": 385769,
	"./sectionTooth_5/13.stl": 158851,
	"./sectionTooth_5/14.stl": 978822,
	"./sectionTooth_5/15.stl": 353946,
	"./sectionTooth_5/16.stl": 863087,
	"./sectionTooth_5/17.stl": 426880,
	"./sectionTooth_5/18.stl": 617250,
	"./sectionTooth_5/21.stl": 636020,
	"./sectionTooth_5/22.stl": 824629,
	"./sectionTooth_5/23.stl": 780813,
	"./sectionTooth_5/24.stl": 224589,
	"./sectionTooth_5/25.stl": 694061,
	"./sectionTooth_5/26.stl": 698104,
	"./sectionTooth_5/27.stl": 904476,
	"./sectionTooth_5/28.stl": 697633,
	"./sectionTooth_5/31.stl": 484715,
	"./sectionTooth_5/32.stl": 455098,
	"./sectionTooth_5/33.stl": 824563,
	"./sectionTooth_5/34.stl": 330167,
	"./sectionTooth_5/35.stl": 869885,
	"./sectionTooth_5/36.stl": 629049,
	"./sectionTooth_5/37.stl": 319189,
	"./sectionTooth_5/38.stl": 641851,
	"./sectionTooth_5/41.stl": 340195,
	"./sectionTooth_5/42.stl": 510736,
	"./sectionTooth_5/43.stl": 28789,
	"./sectionTooth_5/44.stl": 635287,
	"./sectionTooth_5/45.stl": 70397,
	"./sectionTooth_5/46.stl": 834876,
	"./sectionTooth_5/47.stl": 46262,
	"./sectionTooth_5/48.stl": 748230,
	"./sectionTooth_6/11.stl": 58574,
	"./sectionTooth_6/12.stl": 947405,
	"./sectionTooth_6/13.stl": 117385,
	"./sectionTooth_6/14.stl": 327533,
	"./sectionTooth_6/15.stl": 885105,
	"./sectionTooth_6/16.stl": 490888,
	"./sectionTooth_6/17.stl": 366959,
	"./sectionTooth_6/18.stl": 741640,
	"./sectionTooth_6/21.stl": 577176,
	"./sectionTooth_6/22.stl": 476680,
	"./sectionTooth_6/23.stl": 26159,
	"./sectionTooth_6/24.stl": 402727,
	"./sectionTooth_6/25.stl": 825862,
	"./sectionTooth_6/26.stl": 777674,
	"./sectionTooth_6/27.stl": 428539,
	"./sectionTooth_6/28.stl": 483286,
	"./sectionTooth_6/31.stl": 34944,
	"./sectionTooth_6/32.stl": 903519,
	"./sectionTooth_6/33.stl": 109028,
	"./sectionTooth_6/34.stl": 70194,
	"./sectionTooth_6/35.stl": 602247,
	"./sectionTooth_6/36.stl": 573277,
	"./sectionTooth_6/37.stl": 266623,
	"./sectionTooth_6/38.stl": 944954,
	"./sectionTooth_6/41.stl": 699140,
	"./sectionTooth_6/42.stl": 448983,
	"./sectionTooth_6/43.stl": 934294,
	"./sectionTooth_6/44.stl": 564571,
	"./sectionTooth_6/45.stl": 560275,
	"./sectionTooth_6/46.stl": 33151,
	"./sectionTooth_6/47.stl": 829694,
	"./sectionTooth_6/48.stl": 940740,
	"./sectionTooth_7/11.stl": 373944,
	"./sectionTooth_7/12.stl": 892527,
	"./sectionTooth_7/13.stl": 47524,
	"./sectionTooth_7/14.stl": 353037,
	"./sectionTooth_7/15.stl": 783141,
	"./sectionTooth_7/16.stl": 962982,
	"./sectionTooth_7/17.stl": 575360,
	"./sectionTooth_7/18.stl": 268957,
	"./sectionTooth_7/21.stl": 272705,
	"./sectionTooth_7/22.stl": 48739,
	"./sectionTooth_7/23.stl": 314029,
	"./sectionTooth_7/24.stl": 937113,
	"./sectionTooth_7/25.stl": 95035,
	"./sectionTooth_7/26.stl": 972324,
	"./sectionTooth_7/27.stl": 985008,
	"./sectionTooth_7/28.stl": 960046,
	"./sectionTooth_7/31.stl": 721555,
	"./sectionTooth_7/32.stl": 423955,
	"./sectionTooth_7/33.stl": 347528,
	"./sectionTooth_7/34.stl": 707226,
	"./sectionTooth_7/35.stl": 42792,
	"./sectionTooth_7/36.stl": 766779,
	"./sectionTooth_7/37.stl": 347527,
	"./sectionTooth_7/38.stl": 566273,
	"./sectionTooth_7/41.stl": 673448,
	"./sectionTooth_7/42.stl": 477741,
	"./sectionTooth_7/43.stl": 466603,
	"./sectionTooth_7/44.stl": 629968,
	"./sectionTooth_7/45.stl": 731012,
	"./sectionTooth_7/46.stl": 948856,
	"./sectionTooth_7/47.stl": 442015,
	"./sectionTooth_7/48.stl": 415052,
	"./sinuses/liftingSinusesLeft.stl": 882715,
	"./sinuses/liftingSinusesRight.stl": 294187,
	"./sinuses/lowSinusesLeft.stl": 500401,
	"./sinuses/lowSinusesRight.stl": 926046,
	"./sinuses/normalSinusesLeft.stl": 101323,
	"./sinuses/normalSinusesRight.stl": 455044,
	"./slides/aligners/alignersBottom_1.stl": 263592,
	"./slides/aligners/alignersBottom_10.stl": 25019,
	"./slides/aligners/alignersBottom_2.stl": 238156,
	"./slides/aligners/alignersBottom_3.stl": 902036,
	"./slides/aligners/alignersBottom_4.stl": 739157,
	"./slides/aligners/alignersBottom_5.stl": 564454,
	"./slides/aligners/alignersBottom_6.stl": 877557,
	"./slides/aligners/alignersBottom_7.stl": 533509,
	"./slides/aligners/alignersBottom_8.stl": 796697,
	"./slides/aligners/alignersBottom_9.stl": 557426,
	"./slides/aligners/alignersTop_1.stl": 274935,
	"./slides/aligners/alignersTop_10.stl": 825128,
	"./slides/aligners/alignersTop_2.stl": 648321,
	"./slides/aligners/alignersTop_3.stl": 994113,
	"./slides/aligners/alignersTop_4.stl": 21290,
	"./slides/aligners/alignersTop_5.stl": 229249,
	"./slides/aligners/alignersTop_6.stl": 746921,
	"./slides/aligners/alignersTop_7.stl": 404643,
	"./slides/aligners/alignersTop_8.stl": 977653,
	"./slides/aligners/alignersTop_9.stl": 77111,
	"./slides/ceramicBraces/ceramicBracesBottom_1.stl": 707323,
	"./slides/ceramicBraces/ceramicBracesBottom_10.stl": 548105,
	"./slides/ceramicBraces/ceramicBracesBottom_2.stl": 529810,
	"./slides/ceramicBraces/ceramicBracesBottom_3.stl": 77528,
	"./slides/ceramicBraces/ceramicBracesBottom_4.stl": 481309,
	"./slides/ceramicBraces/ceramicBracesBottom_5.stl": 765185,
	"./slides/ceramicBraces/ceramicBracesBottom_6.stl": 331756,
	"./slides/ceramicBraces/ceramicBracesBottom_7.stl": 609595,
	"./slides/ceramicBraces/ceramicBracesBottom_8.stl": 177267,
	"./slides/ceramicBraces/ceramicBracesBottom_9.stl": 532842,
	"./slides/ceramicBraces/ceramicBracesTop_1.stl": 965043,
	"./slides/ceramicBraces/ceramicBracesTop_10.stl": 516316,
	"./slides/ceramicBraces/ceramicBracesTop_2.stl": 524313,
	"./slides/ceramicBraces/ceramicBracesTop_3.stl": 935107,
	"./slides/ceramicBraces/ceramicBracesTop_4.stl": 923101,
	"./slides/ceramicBraces/ceramicBracesTop_5.stl": 989892,
	"./slides/ceramicBraces/ceramicBracesTop_6.stl": 248768,
	"./slides/ceramicBraces/ceramicBracesTop_7.stl": 438532,
	"./slides/ceramicBraces/ceramicBracesTop_8.stl": 70187,
	"./slides/ceramicBraces/ceramicBracesTop_9.stl": 131548,
	"./slides/ceramicRubber/ceramicRubberBottom_1.stl": 892458,
	"./slides/ceramicRubber/ceramicRubberBottom_10.stl": 997811,
	"./slides/ceramicRubber/ceramicRubberBottom_2.stl": 596599,
	"./slides/ceramicRubber/ceramicRubberBottom_3.stl": 105872,
	"./slides/ceramicRubber/ceramicRubberBottom_4.stl": 816570,
	"./slides/ceramicRubber/ceramicRubberBottom_5.stl": 938615,
	"./slides/ceramicRubber/ceramicRubberBottom_6.stl": 334167,
	"./slides/ceramicRubber/ceramicRubberBottom_7.stl": 557431,
	"./slides/ceramicRubber/ceramicRubberBottom_8.stl": 422959,
	"./slides/ceramicRubber/ceramicRubberBottom_9.stl": 587550,
	"./slides/ceramicRubber/ceramicRubberTop_1.stl": 288521,
	"./slides/ceramicRubber/ceramicRubberTop_10.stl": 545455,
	"./slides/ceramicRubber/ceramicRubberTop_2.stl": 976119,
	"./slides/ceramicRubber/ceramicRubberTop_3.stl": 3339,
	"./slides/ceramicRubber/ceramicRubberTop_4.stl": 497419,
	"./slides/ceramicRubber/ceramicRubberTop_5.stl": 94599,
	"./slides/ceramicRubber/ceramicRubberTop_6.stl": 604591,
	"./slides/ceramicRubber/ceramicRubberTop_7.stl": 442406,
	"./slides/ceramicRubber/ceramicRubberTop_8.stl": 777063,
	"./slides/ceramicRubber/ceramicRubberTop_9.stl": 777172,
	"./slides/frontArc/frontArcBottom_1.stl": 893177,
	"./slides/frontArc/frontArcBottom_10.stl": 117407,
	"./slides/frontArc/frontArcBottom_2.stl": 190413,
	"./slides/frontArc/frontArcBottom_3.stl": 540260,
	"./slides/frontArc/frontArcBottom_4.stl": 410169,
	"./slides/frontArc/frontArcBottom_5.stl": 978852,
	"./slides/frontArc/frontArcBottom_6.stl": 206681,
	"./slides/frontArc/frontArcBottom_7.stl": 205859,
	"./slides/frontArc/frontArcBottom_8.stl": 149831,
	"./slides/frontArc/frontArcBottom_9.stl": 439900,
	"./slides/frontArc/frontArcTop_1.stl": 667435,
	"./slides/frontArc/frontArcTop_10.stl": 946079,
	"./slides/frontArc/frontArcTop_2.stl": 723903,
	"./slides/frontArc/frontArcTop_3.stl": 576034,
	"./slides/frontArc/frontArcTop_4.stl": 247458,
	"./slides/frontArc/frontArcTop_5.stl": 334330,
	"./slides/frontArc/frontArcTop_6.stl": 86190,
	"./slides/frontArc/frontArcTop_7.stl": 73159,
	"./slides/frontArc/frontArcTop_8.stl": 241498,
	"./slides/frontArc/frontArcTop_9.stl": 700411,
	"./slides/gum/gumBottom.stl": 463544,
	"./slides/gum/gumTop.stl": 12549,
	"./slides/lingualArc/lingualArcBottom_1.stl": 959942,
	"./slides/lingualArc/lingualArcBottom_10.stl": 580109,
	"./slides/lingualArc/lingualArcBottom_2.stl": 381564,
	"./slides/lingualArc/lingualArcBottom_3.stl": 16269,
	"./slides/lingualArc/lingualArcBottom_4.stl": 838665,
	"./slides/lingualArc/lingualArcBottom_5.stl": 19160,
	"./slides/lingualArc/lingualArcBottom_6.stl": 14147,
	"./slides/lingualArc/lingualArcBottom_7.stl": 274702,
	"./slides/lingualArc/lingualArcBottom_8.stl": 145600,
	"./slides/lingualArc/lingualArcBottom_9.stl": 297527,
	"./slides/lingualArc/lingualArcTop_1.stl": 656314,
	"./slides/lingualArc/lingualArcTop_10.stl": 955181,
	"./slides/lingualArc/lingualArcTop_2.stl": 34127,
	"./slides/lingualArc/lingualArcTop_3.stl": 666402,
	"./slides/lingualArc/lingualArcTop_4.stl": 635773,
	"./slides/lingualArc/lingualArcTop_5.stl": 925776,
	"./slides/lingualArc/lingualArcTop_6.stl": 920230,
	"./slides/lingualArc/lingualArcTop_7.stl": 911441,
	"./slides/lingualArc/lingualArcTop_8.stl": 878815,
	"./slides/lingualArc/lingualArcTop_9.stl": 539939,
	"./slides/lingualBraces/lingualBracesBottom_1.stl": 126222,
	"./slides/lingualBraces/lingualBracesBottom_10.stl": 924124,
	"./slides/lingualBraces/lingualBracesBottom_2.stl": 436117,
	"./slides/lingualBraces/lingualBracesBottom_3.stl": 292826,
	"./slides/lingualBraces/lingualBracesBottom_4.stl": 224523,
	"./slides/lingualBraces/lingualBracesBottom_5.stl": 466333,
	"./slides/lingualBraces/lingualBracesBottom_6.stl": 593079,
	"./slides/lingualBraces/lingualBracesBottom_7.stl": 635102,
	"./slides/lingualBraces/lingualBracesBottom_8.stl": 499427,
	"./slides/lingualBraces/lingualBracesBottom_9.stl": 881159,
	"./slides/lingualBraces/lingualBracesTop_1.stl": 340463,
	"./slides/lingualBraces/lingualBracesTop_10.stl": 774530,
	"./slides/lingualBraces/lingualBracesTop_2.stl": 852392,
	"./slides/lingualBraces/lingualBracesTop_3.stl": 202782,
	"./slides/lingualBraces/lingualBracesTop_4.stl": 614213,
	"./slides/lingualBraces/lingualBracesTop_5.stl": 710590,
	"./slides/lingualBraces/lingualBracesTop_6.stl": 841176,
	"./slides/lingualBraces/lingualBracesTop_7.stl": 50263,
	"./slides/lingualBraces/lingualBracesTop_8.stl": 788880,
	"./slides/lingualBraces/lingualBracesTop_9.stl": 897346,
	"./slides/lingualRubber/lingualRubberBottom_1.stl": 2940,
	"./slides/lingualRubber/lingualRubberBottom_10.stl": 809137,
	"./slides/lingualRubber/lingualRubberBottom_2.stl": 365958,
	"./slides/lingualRubber/lingualRubberBottom_3.stl": 508835,
	"./slides/lingualRubber/lingualRubberBottom_4.stl": 920774,
	"./slides/lingualRubber/lingualRubberBottom_5.stl": 392777,
	"./slides/lingualRubber/lingualRubberBottom_6.stl": 311965,
	"./slides/lingualRubber/lingualRubberBottom_7.stl": 509862,
	"./slides/lingualRubber/lingualRubberBottom_8.stl": 816603,
	"./slides/lingualRubber/lingualRubberBottom_9.stl": 140017,
	"./slides/lingualRubber/lingualRubberTop_1.stl": 527146,
	"./slides/lingualRubber/lingualRubberTop_10.stl": 67675,
	"./slides/lingualRubber/lingualRubberTop_2.stl": 731078,
	"./slides/lingualRubber/lingualRubberTop_3.stl": 933190,
	"./slides/lingualRubber/lingualRubberTop_4.stl": 308586,
	"./slides/lingualRubber/lingualRubberTop_5.stl": 664388,
	"./slides/lingualRubber/lingualRubberTop_6.stl": 898228,
	"./slides/lingualRubber/lingualRubberTop_7.stl": 728009,
	"./slides/lingualRubber/lingualRubberTop_8.stl": 139268,
	"./slides/lingualRubber/lingualRubberTop_9.stl": 501783,
	"./slides/metallBraces/metallBracesBottom_1.stl": 473833,
	"./slides/metallBraces/metallBracesBottom_10.stl": 154708,
	"./slides/metallBraces/metallBracesBottom_2.stl": 491280,
	"./slides/metallBraces/metallBracesBottom_3.stl": 603616,
	"./slides/metallBraces/metallBracesBottom_4.stl": 246123,
	"./slides/metallBraces/metallBracesBottom_5.stl": 576174,
	"./slides/metallBraces/metallBracesBottom_6.stl": 817291,
	"./slides/metallBraces/metallBracesBottom_7.stl": 671893,
	"./slides/metallBraces/metallBracesBottom_8.stl": 534905,
	"./slides/metallBraces/metallBracesBottom_9.stl": 182285,
	"./slides/metallBraces/metallBracesTop_1.stl": 162142,
	"./slides/metallBraces/metallBracesTop_10.stl": 244179,
	"./slides/metallBraces/metallBracesTop_2.stl": 320414,
	"./slides/metallBraces/metallBracesTop_3.stl": 228414,
	"./slides/metallBraces/metallBracesTop_4.stl": 385955,
	"./slides/metallBraces/metallBracesTop_5.stl": 956935,
	"./slides/metallBraces/metallBracesTop_6.stl": 589156,
	"./slides/metallBraces/metallBracesTop_7.stl": 316444,
	"./slides/metallBraces/metallBracesTop_8.stl": 123365,
	"./slides/metallBraces/metallBracesTop_9.stl": 81803,
	"./slides/metallRubber/metallRubberBottom_1.stl": 752500,
	"./slides/metallRubber/metallRubberBottom_10.stl": 700571,
	"./slides/metallRubber/metallRubberBottom_2.stl": 651472,
	"./slides/metallRubber/metallRubberBottom_3.stl": 358758,
	"./slides/metallRubber/metallRubberBottom_4.stl": 233185,
	"./slides/metallRubber/metallRubberBottom_5.stl": 272450,
	"./slides/metallRubber/metallRubberBottom_6.stl": 284615,
	"./slides/metallRubber/metallRubberBottom_7.stl": 588838,
	"./slides/metallRubber/metallRubberBottom_8.stl": 557215,
	"./slides/metallRubber/metallRubberBottom_9.stl": 464555,
	"./slides/metallRubber/metallRubberTop_1.stl": 791,
	"./slides/metallRubber/metallRubberTop_10.stl": 24108,
	"./slides/metallRubber/metallRubberTop_2.stl": 996473,
	"./slides/metallRubber/metallRubberTop_3.stl": 965825,
	"./slides/metallRubber/metallRubberTop_4.stl": 397221,
	"./slides/metallRubber/metallRubberTop_5.stl": 334014,
	"./slides/metallRubber/metallRubberTop_6.stl": 590560,
	"./slides/metallRubber/metallRubberTop_7.stl": 609021,
	"./slides/metallRubber/metallRubberTop_8.stl": 914704,
	"./slides/metallRubber/metallRubberTop_9.stl": 847556,
	"./slides/selfAlignBraces/selfAlignBracesBottom_1.stl": 559569,
	"./slides/selfAlignBraces/selfAlignBracesBottom_10.stl": 82470,
	"./slides/selfAlignBraces/selfAlignBracesBottom_2.stl": 251909,
	"./slides/selfAlignBraces/selfAlignBracesBottom_3.stl": 928153,
	"./slides/selfAlignBraces/selfAlignBracesBottom_4.stl": 556999,
	"./slides/selfAlignBraces/selfAlignBracesBottom_5.stl": 937309,
	"./slides/selfAlignBraces/selfAlignBracesBottom_6.stl": 334171,
	"./slides/selfAlignBraces/selfAlignBracesBottom_7.stl": 588870,
	"./slides/selfAlignBraces/selfAlignBracesBottom_8.stl": 165253,
	"./slides/selfAlignBraces/selfAlignBracesBottom_9.stl": 239724,
	"./slides/selfAlignBraces/selfAlignBracesTop_1.stl": 350530,
	"./slides/selfAlignBraces/selfAlignBracesTop_10.stl": 660363,
	"./slides/selfAlignBraces/selfAlignBracesTop_2.stl": 298945,
	"./slides/selfAlignBraces/selfAlignBracesTop_3.stl": 166881,
	"./slides/selfAlignBraces/selfAlignBracesTop_4.stl": 132188,
	"./slides/selfAlignBraces/selfAlignBracesTop_5.stl": 406357,
	"./slides/selfAlignBraces/selfAlignBracesTop_6.stl": 622683,
	"./slides/selfAlignBraces/selfAlignBracesTop_7.stl": 581220,
	"./slides/selfAlignBraces/selfAlignBracesTop_8.stl": 162395,
	"./slides/selfAlignBraces/selfAlignBracesTop_9.stl": 45185,
	"./slides/tooth/_11_1.stl": 720628,
	"./slides/tooth/_11_10.stl": 40760,
	"./slides/tooth/_11_2.stl": 47345,
	"./slides/tooth/_11_3.stl": 924480,
	"./slides/tooth/_11_4.stl": 535519,
	"./slides/tooth/_11_5.stl": 327725,
	"./slides/tooth/_11_6.stl": 436957,
	"./slides/tooth/_11_7.stl": 448893,
	"./slides/tooth/_11_8.stl": 529681,
	"./slides/tooth/_11_9.stl": 391286,
	"./slides/tooth/_12_1.stl": 604448,
	"./slides/tooth/_12_10.stl": 347663,
	"./slides/tooth/_12_2.stl": 289060,
	"./slides/tooth/_12_3.stl": 979133,
	"./slides/tooth/_12_4.stl": 488935,
	"./slides/tooth/_12_5.stl": 936438,
	"./slides/tooth/_12_6.stl": 850135,
	"./slides/tooth/_12_7.stl": 432010,
	"./slides/tooth/_12_8.stl": 45804,
	"./slides/tooth/_12_9.stl": 410186,
	"./slides/tooth/_13_1.stl": 629752,
	"./slides/tooth/_13_10.stl": 98882,
	"./slides/tooth/_13_2.stl": 439229,
	"./slides/tooth/_13_3.stl": 404141,
	"./slides/tooth/_13_4.stl": 257466,
	"./slides/tooth/_13_5.stl": 883549,
	"./slides/tooth/_13_6.stl": 190917,
	"./slides/tooth/_13_7.stl": 726058,
	"./slides/tooth/_13_8.stl": 794484,
	"./slides/tooth/_13_9.stl": 323522,
	"./slides/tooth/_14_1.stl": 741418,
	"./slides/tooth/_14_10.stl": 884115,
	"./slides/tooth/_14_2.stl": 258673,
	"./slides/tooth/_14_3.stl": 901675,
	"./slides/tooth/_14_4.stl": 552355,
	"./slides/tooth/_14_5.stl": 555904,
	"./slides/tooth/_14_6.stl": 484870,
	"./slides/tooth/_14_7.stl": 481399,
	"./slides/tooth/_14_8.stl": 16727,
	"./slides/tooth/_14_9.stl": 792590,
	"./slides/tooth/_15_1.stl": 587086,
	"./slides/tooth/_15_10.stl": 821443,
	"./slides/tooth/_15_2.stl": 78479,
	"./slides/tooth/_15_3.stl": 959661,
	"./slides/tooth/_15_4.stl": 841601,
	"./slides/tooth/_15_5.stl": 816039,
	"./slides/tooth/_15_6.stl": 89679,
	"./slides/tooth/_15_7.stl": 404133,
	"./slides/tooth/_15_8.stl": 191826,
	"./slides/tooth/_15_9.stl": 754897,
	"./slides/tooth/_16_1.stl": 962125,
	"./slides/tooth/_16_10.stl": 920466,
	"./slides/tooth/_16_2.stl": 328597,
	"./slides/tooth/_16_3.stl": 917838,
	"./slides/tooth/_16_4.stl": 213024,
	"./slides/tooth/_16_5.stl": 46735,
	"./slides/tooth/_16_6.stl": 444927,
	"./slides/tooth/_16_7.stl": 326666,
	"./slides/tooth/_16_8.stl": 869513,
	"./slides/tooth/_16_9.stl": 490181,
	"./slides/tooth/_17_1.stl": 497974,
	"./slides/tooth/_17_10.stl": 906177,
	"./slides/tooth/_17_2.stl": 814908,
	"./slides/tooth/_17_3.stl": 393557,
	"./slides/tooth/_17_4.stl": 320915,
	"./slides/tooth/_17_5.stl": 425210,
	"./slides/tooth/_17_6.stl": 635311,
	"./slides/tooth/_17_7.stl": 480804,
	"./slides/tooth/_17_8.stl": 687228,
	"./slides/tooth/_17_9.stl": 682330,
	"./slides/tooth/_21_1.stl": 618931,
	"./slides/tooth/_21_10.stl": 596371,
	"./slides/tooth/_21_2.stl": 510995,
	"./slides/tooth/_21_3.stl": 26263,
	"./slides/tooth/_21_4.stl": 643613,
	"./slides/tooth/_21_5.stl": 979044,
	"./slides/tooth/_21_6.stl": 621993,
	"./slides/tooth/_21_7.stl": 722612,
	"./slides/tooth/_21_8.stl": 816490,
	"./slides/tooth/_21_9.stl": 723609,
	"./slides/tooth/_22_1.stl": 238734,
	"./slides/tooth/_22_10.stl": 258409,
	"./slides/tooth/_22_2.stl": 450563,
	"./slides/tooth/_22_3.stl": 457277,
	"./slides/tooth/_22_4.stl": 820548,
	"./slides/tooth/_22_5.stl": 751939,
	"./slides/tooth/_22_6.stl": 390620,
	"./slides/tooth/_22_7.stl": 557853,
	"./slides/tooth/_22_8.stl": 771082,
	"./slides/tooth/_22_9.stl": 179834,
	"./slides/tooth/_23_1.stl": 519892,
	"./slides/tooth/_23_10.stl": 130835,
	"./slides/tooth/_23_2.stl": 984406,
	"./slides/tooth/_23_3.stl": 120531,
	"./slides/tooth/_23_4.stl": 936709,
	"./slides/tooth/_23_5.stl": 298084,
	"./slides/tooth/_23_6.stl": 509219,
	"./slides/tooth/_23_7.stl": 718113,
	"./slides/tooth/_23_8.stl": 157580,
	"./slides/tooth/_23_9.stl": 43058,
	"./slides/tooth/_24_1.stl": 503654,
	"./slides/tooth/_24_10.stl": 352568,
	"./slides/tooth/_24_2.stl": 508314,
	"./slides/tooth/_24_3.stl": 489023,
	"./slides/tooth/_24_4.stl": 704824,
	"./slides/tooth/_24_5.stl": 642636,
	"./slides/tooth/_24_6.stl": 543276,
	"./slides/tooth/_24_7.stl": 514889,
	"./slides/tooth/_24_8.stl": 517333,
	"./slides/tooth/_24_9.stl": 46966,
	"./slides/tooth/_25_1.stl": 350985,
	"./slides/tooth/_25_10.stl": 661684,
	"./slides/tooth/_25_2.stl": 771629,
	"./slides/tooth/_25_3.stl": 19292,
	"./slides/tooth/_25_4.stl": 177144,
	"./slides/tooth/_25_5.stl": 47363,
	"./slides/tooth/_25_6.stl": 80424,
	"./slides/tooth/_25_7.stl": 366582,
	"./slides/tooth/_25_8.stl": 845778,
	"./slides/tooth/_25_9.stl": 92091,
	"./slides/tooth/_26_1.stl": 876601,
	"./slides/tooth/_26_10.stl": 684920,
	"./slides/tooth/_26_2.stl": 359865,
	"./slides/tooth/_26_3.stl": 783835,
	"./slides/tooth/_26_4.stl": 475806,
	"./slides/tooth/_26_5.stl": 974263,
	"./slides/tooth/_26_6.stl": 377232,
	"./slides/tooth/_26_7.stl": 890028,
	"./slides/tooth/_26_8.stl": 427764,
	"./slides/tooth/_26_9.stl": 991419,
	"./slides/tooth/_27_1.stl": 188963,
	"./slides/tooth/_27_10.stl": 525761,
	"./slides/tooth/_27_2.stl": 909126,
	"./slides/tooth/_27_3.stl": 308432,
	"./slides/tooth/_27_4.stl": 42883,
	"./slides/tooth/_27_5.stl": 548638,
	"./slides/tooth/_27_6.stl": 740164,
	"./slides/tooth/_27_7.stl": 157205,
	"./slides/tooth/_27_8.stl": 969954,
	"./slides/tooth/_27_9.stl": 667291,
	"./slides/tooth/_31_1.stl": 117372,
	"./slides/tooth/_31_10.stl": 757210,
	"./slides/tooth/_31_2.stl": 970010,
	"./slides/tooth/_31_3.stl": 987747,
	"./slides/tooth/_31_4.stl": 773038,
	"./slides/tooth/_31_5.stl": 519437,
	"./slides/tooth/_31_6.stl": 876619,
	"./slides/tooth/_31_7.stl": 572359,
	"./slides/tooth/_31_8.stl": 80824,
	"./slides/tooth/_31_9.stl": 100361,
	"./slides/tooth/_32_1.stl": 525092,
	"./slides/tooth/_32_10.stl": 827473,
	"./slides/tooth/_32_2.stl": 469326,
	"./slides/tooth/_32_3.stl": 790491,
	"./slides/tooth/_32_4.stl": 55505,
	"./slides/tooth/_32_5.stl": 235171,
	"./slides/tooth/_32_6.stl": 285378,
	"./slides/tooth/_32_7.stl": 978848,
	"./slides/tooth/_32_8.stl": 933170,
	"./slides/tooth/_32_9.stl": 242704,
	"./slides/tooth/_33_1.stl": 97926,
	"./slides/tooth/_33_10.stl": 352570,
	"./slides/tooth/_33_2.stl": 907489,
	"./slides/tooth/_33_3.stl": 113185,
	"./slides/tooth/_33_4.stl": 110955,
	"./slides/tooth/_33_5.stl": 674253,
	"./slides/tooth/_33_6.stl": 227398,
	"./slides/tooth/_33_7.stl": 701425,
	"./slides/tooth/_33_8.stl": 294641,
	"./slides/tooth/_33_9.stl": 585031,
	"./slides/tooth/_34_1.stl": 207613,
	"./slides/tooth/_34_10.stl": 315025,
	"./slides/tooth/_34_2.stl": 259088,
	"./slides/tooth/_34_3.stl": 664037,
	"./slides/tooth/_34_4.stl": 599502,
	"./slides/tooth/_34_5.stl": 622140,
	"./slides/tooth/_34_6.stl": 48820,
	"./slides/tooth/_34_7.stl": 724494,
	"./slides/tooth/_34_8.stl": 732060,
	"./slides/tooth/_34_9.stl": 595691,
	"./slides/tooth/_35_1.stl": 874566,
	"./slides/tooth/_35_10.stl": 955821,
	"./slides/tooth/_35_2.stl": 275333,
	"./slides/tooth/_35_3.stl": 991548,
	"./slides/tooth/_35_4.stl": 140240,
	"./slides/tooth/_35_5.stl": 153620,
	"./slides/tooth/_35_6.stl": 815202,
	"./slides/tooth/_35_7.stl": 145002,
	"./slides/tooth/_35_8.stl": 778023,
	"./slides/tooth/_35_9.stl": 477941,
	"./slides/tooth/_36_1.stl": 187309,
	"./slides/tooth/_36_10.stl": 261282,
	"./slides/tooth/_36_2.stl": 512900,
	"./slides/tooth/_36_3.stl": 417961,
	"./slides/tooth/_36_4.stl": 689046,
	"./slides/tooth/_36_5.stl": 705648,
	"./slides/tooth/_36_6.stl": 50594,
	"./slides/tooth/_36_7.stl": 963233,
	"./slides/tooth/_36_8.stl": 674111,
	"./slides/tooth/_36_9.stl": 227913,
	"./slides/tooth/_37_1.stl": 492327,
	"./slides/tooth/_37_10.stl": 820667,
	"./slides/tooth/_37_2.stl": 391849,
	"./slides/tooth/_37_3.stl": 380457,
	"./slides/tooth/_37_4.stl": 812420,
	"./slides/tooth/_37_5.stl": 537814,
	"./slides/tooth/_37_6.stl": 713002,
	"./slides/tooth/_37_7.stl": 140314,
	"./slides/tooth/_37_8.stl": 936420,
	"./slides/tooth/_37_9.stl": 376167,
	"./slides/tooth/_41_1.stl": 377784,
	"./slides/tooth/_41_10.stl": 885379,
	"./slides/tooth/_41_2.stl": 847490,
	"./slides/tooth/_41_3.stl": 524927,
	"./slides/tooth/_41_4.stl": 735329,
	"./slides/tooth/_41_5.stl": 603091,
	"./slides/tooth/_41_6.stl": 678933,
	"./slides/tooth/_41_7.stl": 755743,
	"./slides/tooth/_41_8.stl": 118552,
	"./slides/tooth/_41_9.stl": 200090,
	"./slides/tooth/_42_1.stl": 531790,
	"./slides/tooth/_42_10.stl": 793199,
	"./slides/tooth/_42_2.stl": 395926,
	"./slides/tooth/_42_3.stl": 504265,
	"./slides/tooth/_42_4.stl": 522983,
	"./slides/tooth/_42_5.stl": 500962,
	"./slides/tooth/_42_6.stl": 528057,
	"./slides/tooth/_42_7.stl": 170386,
	"./slides/tooth/_42_8.stl": 973951,
	"./slides/tooth/_42_9.stl": 362249,
	"./slides/tooth/_43_1.stl": 194603,
	"./slides/tooth/_43_10.stl": 951539,
	"./slides/tooth/_43_2.stl": 555196,
	"./slides/tooth/_43_3.stl": 924598,
	"./slides/tooth/_43_4.stl": 722536,
	"./slides/tooth/_43_5.stl": 875654,
	"./slides/tooth/_43_6.stl": 811804,
	"./slides/tooth/_43_7.stl": 55666,
	"./slides/tooth/_43_8.stl": 400627,
	"./slides/tooth/_43_9.stl": 850102,
	"./slides/tooth/_44_1.stl": 246588,
	"./slides/tooth/_44_10.stl": 996072,
	"./slides/tooth/_44_2.stl": 771143,
	"./slides/tooth/_44_3.stl": 539338,
	"./slides/tooth/_44_4.stl": 785156,
	"./slides/tooth/_44_5.stl": 879482,
	"./slides/tooth/_44_6.stl": 448704,
	"./slides/tooth/_44_7.stl": 463907,
	"./slides/tooth/_44_8.stl": 2570,
	"./slides/tooth/_44_9.stl": 626954,
	"./slides/tooth/_45_1.stl": 525932,
	"./slides/tooth/_45_10.stl": 785500,
	"./slides/tooth/_45_2.stl": 39718,
	"./slides/tooth/_45_3.stl": 20423,
	"./slides/tooth/_45_4.stl": 123134,
	"./slides/tooth/_45_5.stl": 223027,
	"./slides/tooth/_45_6.stl": 138355,
	"./slides/tooth/_45_7.stl": 206356,
	"./slides/tooth/_45_8.stl": 528111,
	"./slides/tooth/_45_9.stl": 524846,
	"./slides/tooth/_46_1.stl": 103430,
	"./slides/tooth/_46_10.stl": 952121,
	"./slides/tooth/_46_2.stl": 188201,
	"./slides/tooth/_46_3.stl": 336157,
	"./slides/tooth/_46_4.stl": 961355,
	"./slides/tooth/_46_5.stl": 41384,
	"./slides/tooth/_46_6.stl": 241436,
	"./slides/tooth/_46_7.stl": 573718,
	"./slides/tooth/_46_8.stl": 283501,
	"./slides/tooth/_46_9.stl": 781434,
	"./slides/tooth/_47_1.stl": 442960,
	"./slides/tooth/_47_10.stl": 478408,
	"./slides/tooth/_47_2.stl": 765316,
	"./slides/tooth/_47_3.stl": 996911,
	"./slides/tooth/_47_4.stl": 727235,
	"./slides/tooth/_47_5.stl": 674238,
	"./slides/tooth/_47_6.stl": 865879,
	"./slides/tooth/_47_7.stl": 341226,
	"./slides/tooth/_47_8.stl": 689340,
	"./slides/tooth/_47_9.stl": 126537,
	"./standardAbutment/11.stl": 356235,
	"./standardAbutment/12.stl": 842613,
	"./standardAbutment/13.stl": 55873,
	"./standardAbutment/14.stl": 411966,
	"./standardAbutment/15.stl": 110998,
	"./standardAbutment/16.stl": 651061,
	"./standardAbutment/17.stl": 722146,
	"./standardAbutment/18.stl": 747207,
	"./standardAbutment/21.stl": 39732,
	"./standardAbutment/22.stl": 521763,
	"./standardAbutment/23.stl": 325060,
	"./standardAbutment/24.stl": 411080,
	"./standardAbutment/25.stl": 547330,
	"./standardAbutment/26.stl": 2542,
	"./standardAbutment/27.stl": 938457,
	"./standardAbutment/28.stl": 480939,
	"./standardAbutment/31.stl": 810255,
	"./standardAbutment/32.stl": 416650,
	"./standardAbutment/33.stl": 319590,
	"./standardAbutment/34.stl": 202226,
	"./standardAbutment/35.stl": 462449,
	"./standardAbutment/36.stl": 766969,
	"./standardAbutment/37.stl": 212356,
	"./standardAbutment/38.stl": 449881,
	"./standardAbutment/41.stl": 906578,
	"./standardAbutment/42.stl": 813523,
	"./standardAbutment/43.stl": 288865,
	"./standardAbutment/44.stl": 58114,
	"./standardAbutment/45.stl": 284962,
	"./standardAbutment/46.stl": 583304,
	"./standardAbutment/47.stl": 300928,
	"./standardAbutment/48.stl": 569498,
	"./stumpTab/11.stl": 358696,
	"./stumpTab/12.stl": 104189,
	"./stumpTab/13.stl": 210331,
	"./stumpTab/14.stl": 100614,
	"./stumpTab/15.stl": 22684,
	"./stumpTab/16.stl": 958644,
	"./stumpTab/17.stl": 28337,
	"./stumpTab/18.stl": 897202,
	"./stumpTab/21.stl": 166458,
	"./stumpTab/22.stl": 559017,
	"./stumpTab/23.stl": 938495,
	"./stumpTab/24.stl": 601929,
	"./stumpTab/25.stl": 311572,
	"./stumpTab/26.stl": 272981,
	"./stumpTab/27.stl": 906736,
	"./stumpTab/28.stl": 97921,
	"./stumpTab/31.stl": 710568,
	"./stumpTab/32.stl": 670121,
	"./stumpTab/33.stl": 493576,
	"./stumpTab/34.stl": 191765,
	"./stumpTab/35.stl": 483894,
	"./stumpTab/36.stl": 843199,
	"./stumpTab/37.stl": 1763,
	"./stumpTab/38.stl": 397115,
	"./stumpTab/41.stl": 929902,
	"./stumpTab/42.stl": 902541,
	"./stumpTab/43.stl": 168325,
	"./stumpTab/44.stl": 912235,
	"./stumpTab/45.stl": 350015,
	"./stumpTab/46.stl": 525070,
	"./stumpTab/47.stl": 828986,
	"./stumpTab/48.stl": 654400,
	"./stumpTabTooth/11.stl": 787670,
	"./stumpTabTooth/12.stl": 725158,
	"./stumpTabTooth/13.stl": 707041,
	"./stumpTabTooth/14.stl": 916492,
	"./stumpTabTooth/15.stl": 361137,
	"./stumpTabTooth/16.stl": 188998,
	"./stumpTabTooth/17.stl": 988611,
	"./stumpTabTooth/18.stl": 46959,
	"./stumpTabTooth/21.stl": 470494,
	"./stumpTabTooth/22.stl": 791067,
	"./stumpTabTooth/23.stl": 581742,
	"./stumpTabTooth/24.stl": 402754,
	"./stumpTabTooth/25.stl": 868538,
	"./stumpTabTooth/26.stl": 205274,
	"./stumpTabTooth/27.stl": 661026,
	"./stumpTabTooth/28.stl": 348430,
	"./stumpTabTooth/31.stl": 310162,
	"./stumpTabTooth/32.stl": 64306,
	"./stumpTabTooth/33.stl": 334056,
	"./stumpTabTooth/34.stl": 926824,
	"./stumpTabTooth/35.stl": 650792,
	"./stumpTabTooth/36.stl": 822902,
	"./stumpTabTooth/37.stl": 71834,
	"./stumpTabTooth/38.stl": 422911,
	"./stumpTabTooth/41.stl": 732345,
	"./stumpTabTooth/42.stl": 924827,
	"./stumpTabTooth/43.stl": 369757,
	"./stumpTabTooth/44.stl": 122825,
	"./stumpTabTooth/45.stl": 651929,
	"./stumpTabTooth/46.stl": 951916,
	"./stumpTabTooth/47.stl": 290355,
	"./stumpTabTooth/48.stl": 536786,
	"./syntheticGum/11.stl": 485756,
	"./syntheticGum/12.stl": 887043,
	"./syntheticGum/13.stl": 588662,
	"./syntheticGum/14.stl": 147145,
	"./syntheticGum/15.stl": 581504,
	"./syntheticGum/16.stl": 539268,
	"./syntheticGum/17.stl": 556874,
	"./syntheticGum/21.stl": 524802,
	"./syntheticGum/22.stl": 862493,
	"./syntheticGum/23.stl": 928621,
	"./syntheticGum/24.stl": 779532,
	"./syntheticGum/25.stl": 562793,
	"./syntheticGum/26.stl": 415471,
	"./syntheticGum/27.stl": 592025,
	"./syntheticGum/31.stl": 454281,
	"./syntheticGum/32.stl": 451300,
	"./syntheticGum/33.stl": 675735,
	"./syntheticGum/34.stl": 403644,
	"./syntheticGum/35.stl": 686178,
	"./syntheticGum/36.stl": 148942,
	"./syntheticGum/37.stl": 134467,
	"./syntheticGum/41.stl": 478806,
	"./syntheticGum/42.stl": 240288,
	"./syntheticGum/43.stl": 22452,
	"./syntheticGum/44.stl": 200435,
	"./syntheticGum/45.stl": 336507,
	"./syntheticGum/46.stl": 595979,
	"./syntheticGum/47.stl": 132550,
	"./syntheticTooth/11.stl": 788751,
	"./syntheticTooth/12.stl": 241839,
	"./syntheticTooth/13.stl": 935623,
	"./syntheticTooth/14.stl": 694781,
	"./syntheticTooth/15.stl": 111262,
	"./syntheticTooth/16.stl": 431720,
	"./syntheticTooth/17.stl": 771509,
	"./syntheticTooth/18.stl": 288190,
	"./syntheticTooth/21.stl": 198674,
	"./syntheticTooth/22.stl": 333031,
	"./syntheticTooth/23.stl": 538310,
	"./syntheticTooth/24.stl": 749579,
	"./syntheticTooth/25.stl": 601714,
	"./syntheticTooth/26.stl": 477433,
	"./syntheticTooth/27.stl": 150396,
	"./syntheticTooth/28.stl": 823236,
	"./syntheticTooth/31.stl": 712411,
	"./syntheticTooth/32.stl": 719859,
	"./syntheticTooth/33.stl": 134616,
	"./syntheticTooth/34.stl": 100989,
	"./syntheticTooth/35.stl": 437962,
	"./syntheticTooth/36.stl": 190341,
	"./syntheticTooth/37.stl": 681431,
	"./syntheticTooth/38.stl": 693442,
	"./syntheticTooth/41.stl": 468597,
	"./syntheticTooth/42.stl": 504848,
	"./syntheticTooth/43.stl": 580246,
	"./syntheticTooth/44.stl": 692182,
	"./syntheticTooth/45.stl": 801092,
	"./syntheticTooth/46.stl": 826516,
	"./syntheticTooth/47.stl": 581110,
	"./syntheticTooth/48.stl": 561604,
	"./syntheticToothGum/11.stl": 815548,
	"./syntheticToothGum/12.stl": 976677,
	"./syntheticToothGum/13.stl": 208731,
	"./syntheticToothGum/14.stl": 40372,
	"./syntheticToothGum/15.stl": 321924,
	"./syntheticToothGum/16.stl": 564379,
	"./syntheticToothGum/17.stl": 75373,
	"./syntheticToothGum/18.stl": 720535,
	"./syntheticToothGum/21.stl": 262343,
	"./syntheticToothGum/22.stl": 814159,
	"./syntheticToothGum/23.stl": 887785,
	"./syntheticToothGum/24.stl": 422813,
	"./syntheticToothGum/25.stl": 509516,
	"./syntheticToothGum/26.stl": 271185,
	"./syntheticToothGum/27.stl": 599514,
	"./syntheticToothGum/28.stl": 745548,
	"./syntheticToothGum/31.stl": 82105,
	"./syntheticToothGum/32.stl": 262170,
	"./syntheticToothGum/33.stl": 90502,
	"./syntheticToothGum/34.stl": 918585,
	"./syntheticToothGum/35.stl": 343493,
	"./syntheticToothGum/36.stl": 429608,
	"./syntheticToothGum/37.stl": 211002,
	"./syntheticToothGum/38.stl": 834037,
	"./syntheticToothGum/41.stl": 515208,
	"./syntheticToothGum/42.stl": 57638,
	"./syntheticToothGum/43.stl": 324788,
	"./syntheticToothGum/44.stl": 818728,
	"./syntheticToothGum/45.stl": 723352,
	"./syntheticToothGum/46.stl": 983259,
	"./syntheticToothGum/47.stl": 530949,
	"./syntheticToothGum/48.stl": 447389,
	"./telescopicCrowns/11.stl": 838775,
	"./telescopicCrowns/12.stl": 491319,
	"./telescopicCrowns/13.stl": 110266,
	"./telescopicCrowns/14.stl": 871416,
	"./telescopicCrowns/15.stl": 806659,
	"./telescopicCrowns/16.stl": 594057,
	"./telescopicCrowns/17.stl": 745634,
	"./telescopicCrowns/18.stl": 613840,
	"./telescopicCrowns/21.stl": 994005,
	"./telescopicCrowns/22.stl": 932269,
	"./telescopicCrowns/23.stl": 849556,
	"./telescopicCrowns/24.stl": 859066,
	"./telescopicCrowns/25.stl": 701194,
	"./telescopicCrowns/26.stl": 971657,
	"./telescopicCrowns/27.stl": 288297,
	"./telescopicCrowns/28.stl": 217951,
	"./telescopicCrowns/31.stl": 93343,
	"./telescopicCrowns/32.stl": 708215,
	"./telescopicCrowns/33.stl": 920532,
	"./telescopicCrowns/34.stl": 867062,
	"./telescopicCrowns/35.stl": 197388,
	"./telescopicCrowns/36.stl": 838532,
	"./telescopicCrowns/37.stl": 754014,
	"./telescopicCrowns/38.stl": 594660,
	"./telescopicCrowns/41.stl": 729238,
	"./telescopicCrowns/42.stl": 827693,
	"./telescopicCrowns/43.stl": 836498,
	"./telescopicCrowns/44.stl": 446479,
	"./telescopicCrowns/45.stl": 651866,
	"./telescopicCrowns/46.stl": 129867,
	"./telescopicCrowns/47.stl": 988090,
	"./telescopicCrowns/48.stl": 278346,
	"./totalProsthesis/totalBottom.stl": 409327,
	"./totalProsthesis/totalTop.stl": 178884,
	"./veneerTab/11.stl": 248233,
	"./veneerTab/12.stl": 299137,
	"./veneerTab/13.stl": 359261,
	"./veneerTab/14.stl": 266436,
	"./veneerTab/15.stl": 403170,
	"./veneerTab/16.stl": 473960,
	"./veneerTab/17.stl": 855860,
	"./veneerTab/18.stl": 547507,
	"./veneerTab/21.stl": 970126,
	"./veneerTab/22.stl": 759685,
	"./veneerTab/23.stl": 827705,
	"./veneerTab/24.stl": 400654,
	"./veneerTab/25.stl": 86925,
	"./veneerTab/26.stl": 285098,
	"./veneerTab/27.stl": 252764,
	"./veneerTab/28.stl": 991789,
	"./veneerTab/31.stl": 314270,
	"./veneerTab/32.stl": 380650,
	"./veneerTab/33.stl": 136984,
	"./veneerTab/34.stl": 924188,
	"./veneerTab/35.stl": 149566,
	"./veneerTab/36.stl": 529053,
	"./veneerTab/37.stl": 820811,
	"./veneerTab/38.stl": 800079,
	"./veneerTab/41.stl": 165737,
	"./veneerTab/42.stl": 348067,
	"./veneerTab/43.stl": 795577,
	"./veneerTab/44.stl": 72391,
	"./veneerTab/45.stl": 780574,
	"./veneerTab/46.stl": 258516,
	"./veneerTab/47.stl": 167634,
	"./veneerTab/48.stl": 907570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 414414;